import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: any; output: any; }
  AWSDateTime: { input: any; output: any; }
  AWSEmail: { input: any; output: any; }
  AWSIPAddress: { input: any; output: any; }
  AWSJSON: { input: any; output: any; }
  AWSPhone: { input: any; output: any; }
  AWSTime: { input: any; output: any; }
  AWSTimestamp: { input: any; output: any; }
  AWSURL: { input: any; output: any; }
}

export interface Ad {
  __typename?: 'Ad';
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imageLarge?: Maybe<Scalars['String']['output']>;
  imageLargePublic?: Maybe<Scalars['String']['output']>;
  imageLink?: Maybe<Scalars['String']['output']>;
  imageSmall?: Maybe<Scalars['String']['output']>;
  imageSmallPublic?: Maybe<Scalars['String']['output']>;
  orderDate?: Maybe<Scalars['String']['output']>;
  position?: Maybe<AdPosition>;
  retailerCode?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
}

export interface AdList {
  __typename?: 'AdList';
  items: Array<Maybe<Ad>>;
}

export enum AdPosition {
  Bottom = 'BOTTOM',
  Middle = 'MIDDLE',
  Top = 'TOP'
}

export interface AoStock {
  __typename?: 'AoStock';
  key?: Maybe<StateEnum>;
  value?: Maybe<Scalars['Int']['output']>;
}

export enum AuthProvider {
  ApiKey = 'apiKey',
  Iam = 'iam',
  Oidc = 'oidc',
  UserPools = 'userPools'
}

export interface AuthRule {
  allow: AuthStrategy;
  groupClaim?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupsField?: InputMaybe<Scalars['String']['input']>;
  identityClaim?: InputMaybe<Scalars['String']['input']>;
  mutations?: InputMaybe<Array<InputMaybe<ModelMutation>>>;
  operations?: InputMaybe<Array<InputMaybe<ModelOperation>>>;
  ownerField?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<AuthProvider>;
  queries?: InputMaybe<Array<InputMaybe<ModelQuery>>>;
}

export enum AuthStrategy {
  Groups = 'groups',
  Owner = 'owner',
  Private = 'private',
  Public = 'public'
}

export enum CartItemStatus {
  AdvertNoLongerAvailable = 'ADVERT_NO_LONGER_AVAILABLE',
  InventoryOutOfStock = 'INVENTORY_OUT_OF_STOCK',
  ProductExpired = 'PRODUCT_EXPIRED',
  ProductNotFound = 'PRODUCT_NOT_FOUND',
  Valid = 'VALID',
  VariantNoLongerAvailable = 'VARIANT_NO_LONGER_AVAILABLE'
}

export enum DeliveryMethod {
  Deliver = 'DELIVER',
  NoDispatch = 'NO_DISPATCH',
  PickUpInStore = 'PICK_UP_IN_STORE'
}

export interface GoogleAnalyticsInput {
  clientId?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
}

export interface HttpHeader {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
}

export enum HttpMethod {
  Delete = 'DELETE',
  Get = 'GET',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT'
}

export enum InvoiceStatus {
  AwaitingRefund = 'AWAITING_REFUND',
  AwaitingReturn = 'AWAITING_RETURN',
  Cancelled = 'CANCELLED',
  Collected = 'COLLECTED',
  Paid = 'PAID',
  PartiallySent = 'PARTIALLY_SENT',
  PaymentUnderReview = 'PAYMENT_UNDER_REVIEW',
  Ready = 'READY',
  Refunded = 'REFUNDED',
  Remitted = 'REMITTED',
  Sent = 'SENT'
}

export enum LineItemStatus {
  Allocated = 'ALLOCATED',
  Cancelled = 'CANCELLED',
  New = 'NEW',
  Refunded = 'REFUNDED',
  Shipped = 'SHIPPED'
}

export enum ModelMutation {
  Create = 'create',
  Delete = 'delete',
  Update = 'update'
}

export interface ModelMutationMap {
  create?: InputMaybe<Scalars['String']['input']>;
  delete?: InputMaybe<Scalars['String']['input']>;
  update?: InputMaybe<Scalars['String']['input']>;
}

export enum ModelOperation {
  Create = 'create',
  Delete = 'delete',
  Read = 'read',
  Update = 'update'
}

export enum ModelQuery {
  Get = 'get',
  List = 'list'
}

export interface ModelQueryMap {
  get?: InputMaybe<Scalars['String']['input']>;
  list?: InputMaybe<Scalars['String']['input']>;
}

export enum ModelSubscriptionLevel {
  Off = 'off',
  On = 'on',
  Public = 'public'
}

export interface ModelSubscriptionMap {
  level?: InputMaybe<ModelSubscriptionLevel>;
  onCreate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onDelete?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onUpdate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Mutation {
  __typename?: 'Mutation';
  addItemToCart?: Maybe<CartResult>;
  addToWishList?: Maybe<WishListsResult>;
  checkout?: Maybe<OrderResult>;
  checkoutWithRedirection?: Maybe<CheckoutWithRedirectionResult>;
  deleteItemFromCart?: Maybe<CartResult>;
  deleteUser?: Maybe<DeletedUserResult>;
  processPaymentGatewayRedirect?: Maybe<ProcessPaymentGatewayRedirectResult>;
  removeFromWishList?: Maybe<WishListsResult>;
  saveUserProfile?: Maybe<UserResult>;
  updateCartItem?: Maybe<CartResult>;
  updateCartMetadata?: Maybe<BoolResult>;
  updateCartMetadataCoupon?: Maybe<CartResult>;
}


export interface MutationAddItemToCartArgs {
  advertId: Scalars['String']['input'];
  cartId?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryMethod: DeliveryMethod;
  productId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  variantBarcode?: InputMaybe<Scalars['String']['input']>;
  variantId: Scalars['String']['input'];
}


export interface MutationAddToWishListArgs {
  productId?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationCheckoutArgs {
  cartId?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<InputCheckoutParams>;
}


export interface MutationCheckoutWithRedirectionArgs {
  cartId?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<InputCheckoutParams>;
}


export interface MutationDeleteItemFromCartArgs {
  cartId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
}


export interface MutationProcessPaymentGatewayRedirectArgs {
  input?: InputMaybe<ProcessPaymentGatewayRedirectMutationInput>;
}


export interface MutationRemoveFromWishListArgs {
  productId?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationSaveUserProfileArgs {
  user?: InputMaybe<InputUser>;
}


export interface MutationUpdateCartItemArgs {
  advertId: Scalars['String']['input'];
  cartId?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryMethod?: InputMaybe<DeliveryMethod>;
  id: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  variantId: Scalars['String']['input'];
}


export interface MutationUpdateCartMetadataArgs {
  cartMetadata?: InputMaybe<CartMetadata>;
}


export interface MutationUpdateCartMetadataCouponArgs {
  cartMetadata?: InputMaybe<CartMetadataCoupon>;
}

export enum OrderStatus {
  Abandoned = 'ABANDONED',
  Checkout = 'CHECKOUT',
  Complete = 'COMPLETE',
  New = 'NEW',
  PaymentFailed = 'PAYMENT_FAILED',
  PaymentInProgress = 'PAYMENT_IN_PROGRESS',
  PendingReview = 'PENDING_REVIEW'
}

export enum PaymentProvider {
  Afterpay = 'AFTERPAY',
  Braintree = 'BRAINTREE'
}

export enum PaymentProviderEnum {
  Afterpay = 'AFTERPAY',
  Braintree = 'BRAINTREE'
}

export enum PredictionsActions {
  ConvertTextToSpeech = 'convertTextToSpeech',
  IdentifyLabels = 'identifyLabels',
  IdentifyText = 'identifyText',
  TranslateText = 'translateText'
}

export interface Query {
  __typename?: 'Query';
  getAfterpay?: Maybe<AfterPayResult>;
  getAllBrands: BrandListResult;
  getAllCategories: CategoryListResult;
  getAllRetailers: RetailerListResult;
  getAutocomplete?: Maybe<Autocomplete>;
  getBasicAds?: Maybe<AdListResult>;
  getBrands: BrandListResult;
  getCart?: Maybe<CartResult>;
  getCartById?: Maybe<CartResult>;
  getCategories: CategoryListResult;
  getCategoryByLevelName: CategoryByLevelNameResult;
  getCategoryDetailsById: CategoryListResult;
  getContentById?: Maybe<Content>;
  getFeatures?: Maybe<FeaturesResult>;
  getInventoryForFirstVariant?: Maybe<InventoryResult>;
  getInventoryForVariant?: Maybe<InventoryResult>;
  getOrder?: Maybe<OrderResult>;
  getOrders?: Maybe<OrderListResult>;
  getPaymentToken?: Maybe<PaymentTokenResult>;
  getPremiumAds?: Maybe<AdListResult>;
  getProductGroups: ProductGroupListResult;
  getProductVariantImages?: Maybe<ProductVariantImageListResult>;
  getProducts: ProductListResult;
  getProductsForSearch: ProductListResult;
  getProductsForSearchV2: V2SearchProductListResult;
  getProductsFromPersonalization: ProductListResult;
  getRetailers: RetailerListResult;
  getSimilarProducts: ProductListResult;
  getTopTenCatalogues: ProductGroupListResult;
  getUserProfile?: Maybe<UserResult>;
  getVariantsForAdvert?: Maybe<AdvertVariantListResult>;
  getWishLists?: Maybe<WishListsResult>;
  validateCartDelivery?: Maybe<ProductDeliveryResult>;
}


export interface QueryGetAllBrandsArgs {
  availableForPreference?: InputMaybe<Scalars['Boolean']['input']>;
  filterbyBrands?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
}


export interface QueryGetAllCategoriesArgs {
  availableForPreference?: InputMaybe<Scalars['Boolean']['input']>;
  filterbyCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
}


export interface QueryGetAllRetailersArgs {
  availableForPreference?: InputMaybe<Scalars['Boolean']['input']>;
  filterbyRetailerName?: InputMaybe<Scalars['String']['input']>;
  filterbyRetailers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<InputGeoloc>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
  tier1?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QueryGetAutocompleteArgs {
  searchterm?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryGetBasicAdsArgs {
  position: AdPosition;
}


export interface QueryGetBrandsArgs {
  filterbyBrandName?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  productFilters?: InputMaybe<InputProductFilters>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
}


export interface QueryGetCartArgs {
  cartId?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryGetCartByIdArgs {
  cartId: Scalars['String']['input'];
}


export interface QueryGetCategoriesArgs {
  context?: InputMaybe<CategoryContext>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  parentCategory?: InputMaybe<Scalars['String']['input']>;
  productFilters?: InputMaybe<InputProductFilters>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
}


export interface QueryGetCategoryByLevelNameArgs {
  slug_1?: InputMaybe<Scalars['String']['input']>;
  slug_2?: InputMaybe<Scalars['String']['input']>;
  slug_3?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryGetCategoryDetailsByIdArgs {
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  parentCategory?: InputMaybe<Scalars['String']['input']>;
  productFilters?: InputMaybe<InputProductFilters>;
  sortOrder?: InputMaybe<SortOrder>;
}


export interface QueryGetContentByIdArgs {
  entityFilter?: InputMaybe<InputProductFilters>;
  entityType: EntityType;
  id: Scalars['String']['input'];
}


export interface QueryGetInventoryForFirstVariantArgs {
  advertId: Scalars['ID']['input'];
}


export interface QueryGetInventoryForVariantArgs {
  advertId: Scalars['ID']['input'];
  variantId: Scalars['ID']['input'];
}


export interface QueryGetOrderArgs {
  permalink: Scalars['String']['input'];
}


export interface QueryGetProductGroupsArgs {
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  productFilters?: InputMaybe<InputProductFilters>;
  productGroupFilters?: InputMaybe<InputProductGroupFilters>;
  random?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
  trendingNow?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QueryGetProductVariantImagesArgs {
  advertId: Scalars['String']['input'];
}


export interface QueryGetProductsArgs {
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  productFilters?: InputMaybe<InputProductFilters>;
  random?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
  trendingNow?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QueryGetProductsForSearchArgs {
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  productFilters?: InputMaybe<InputProductFilters>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryGetProductsForSearchV2Args {
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  productFilters?: InputMaybe<InputProductFilters>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
}


export interface QueryGetProductsFromPersonalizationArgs {
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  productFilters?: InputMaybe<InputProductFilters>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
}


export interface QueryGetRetailersArgs {
  filterbyRetailerName?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  productFilters?: InputMaybe<InputProductFilters>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
}


export interface QueryGetSimilarProductsArgs {
  exactMatch?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['String']['input'];
}


export interface QueryGetVariantsForAdvertArgs {
  id: Scalars['String']['input'];
}


export interface QueryValidateCartDeliveryArgs {
  customerPostcode: Scalars['String']['input'];
  productIds: Array<Scalars['Int']['input']>;
}

export interface RedirectConfirmationInput {
  orderToken: Scalars['String']['input'];
  paymentProvider: PaymentProviderEnum;
}

export enum RetailerDeliveryMethod {
  SameDay_2023 = 'SAME_DAY_2023',
  SameDay_2024 = 'SAME_DAY_2024',
  Standard = 'STANDARD'
}

export interface RiskifiedClientDetailInput {
  acceptLanguage: Scalars['String']['input'];
  userAgent: Scalars['String']['input'];
}

export interface RiskifiedPaymentDetailInput {
  bin?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  lastFour?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}

export enum RiskifiedSourceInput {
  DesktopWeb = 'desktop_web',
  MobileApp = 'mobile_app',
  MobileAppAndroid = 'mobile_app_android',
  MobileAppIos = 'mobile_app_ios',
  MobileWeb = 'mobile_web',
  Unknown = 'unknown',
  Web = 'web'
}

export interface RiskifiedSourceProviderInput {
  cartTokenId: Scalars['String']['input'];
  clientDetails: RiskifiedClientDetailInput;
  paymentDetails: RiskifiedPaymentDetailInput;
  referringSite?: InputMaybe<Scalars['String']['input']>;
  source: RiskifiedSourceInput;
}

export interface SearchableQueryMap {
  search?: InputMaybe<Scalars['String']['input']>;
}

export interface ShopbackInput {
  transactionId: Scalars['String']['input'];
}

export enum StateEnum {
  Nsw = 'NSW',
  Nt = 'NT',
  Qld = 'QLD',
  Sa = 'SA',
  Tas = 'TAS',
  Vic = 'VIC',
  Wa = 'WA'
}

export interface Subscription {
  __typename?: 'Subscription';
  subscribeCart?: Maybe<CartResult>;
}


export interface SubscriptionSubscribeCartArgs {
  cartId: Scalars['ID']['input'];
}

export interface TimestampConfiguration {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
}

export type AdListResult = AdList | Error;

export interface Address {
  __typename?: 'address';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressLine3?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
}

export interface Advert {
  __typename?: 'advert';
  aoStockCodes?: Maybe<Array<Maybe<AoStock>>>;
  brand?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayImage?: Maybe<Scalars['String']['output']>;
  displayable?: Maybe<Scalars['Boolean']['output']>;
  editablePrice?: Maybe<Scalars['String']['output']>;
  editableSalePrice?: Maybe<Scalars['String']['output']>;
  fullTitle?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  sellerId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
}

export interface AdvertVariant {
  __typename?: 'advertVariant';
  available?: Maybe<Scalars['Boolean']['output']>;
  buyable?: Maybe<Scalars['Boolean']['output']>;
  countOnHand?: Maybe<Scalars['Int']['output']>;
  displayable?: Maybe<Scalars['Boolean']['output']>;
  editablePrice?: Maybe<Scalars['Float']['output']>;
  editableSalePrice?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  imageUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  infiniteQuantity?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  optionValues?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  published?: Maybe<Scalars['Boolean']['output']>;
  recommendedRetailPrice?: Maybe<Scalars['Float']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  wholesalePrice?: Maybe<Scalars['String']['output']>;
}

export interface AdvertVariantList {
  __typename?: 'advertVariantList';
  aoStockCodes?: Maybe<Array<Maybe<AoStock>>>;
  editablePrice?: Maybe<Scalars['String']['output']>;
  editableSalePrice?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<AdvertVariant>>>;
  total?: Maybe<Scalars['Int']['output']>;
  totalDomesticShippingCostCents?: Maybe<Scalars['Int']['output']>;
}

export type AdvertVariantListResult = AdvertVariantList | Error;

export interface AfterPay {
  __typename?: 'afterPay';
  maxAmount?: Maybe<Scalars['Float']['output']>;
  minAmount?: Maybe<Scalars['Float']['output']>;
}

export type AfterPayResult = AfterPay | Error;

export interface Autocomplete {
  __typename?: 'autocomplete';
  items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  total?: Maybe<Scalars['Int']['output']>;
}

export type BoolResult = Error | SuccessBool;

export interface Brand {
  __typename?: 'brand';
  brand_availableForPreference?: Maybe<Scalars['Boolean']['output']>;
  brand_brandId?: Maybe<Scalars['String']['output']>;
  brand_displayName?: Maybe<Scalars['String']['output']>;
  brand_fashion?: Maybe<Scalars['Boolean']['output']>;
  brand_keyword?: Maybe<Scalars['String']['output']>;
  brand_logoColor?: Maybe<Scalars['String']['output']>;
  brand_logoUrl?: Maybe<Scalars['String']['output']>;
  brand_logoUrlLarge?: Maybe<Scalars['String']['output']>;
  brand_logoUrlSmall?: Maybe<Scalars['String']['output']>;
  brand_name?: Maybe<Scalars['String']['output']>;
  brand_order?: Maybe<Scalars['Int']['output']>;
  brand_productCount?: Maybe<Scalars['String']['output']>;
  brand_sponsorText?: Maybe<Scalars['String']['output']>;
  brand_sponsorUrl?: Maybe<Scalars['String']['output']>;
  brand_tier1?: Maybe<Scalars['Boolean']['output']>;
}

export interface BrandList {
  __typename?: 'brandList';
  items?: Maybe<Array<Maybe<Brand>>>;
  total?: Maybe<Scalars['Int']['output']>;
}

export type BrandListResult = BrandList | Error;

export interface Cart {
  __typename?: 'cart';
  address?: Maybe<CartAddress>;
  billingAddress?: Maybe<CartAddress>;
  billingCompanyName?: Maybe<Scalars['String']['output']>;
  billingEmailAddress?: Maybe<Scalars['String']['output']>;
  billingFirstName?: Maybe<Scalars['String']['output']>;
  billingPhone?: Maybe<Scalars['String']['output']>;
  billingSurname?: Maybe<Scalars['String']['output']>;
  buyableQuantity?: Maybe<Scalars['Int']['output']>;
  cartSellers?: Maybe<Array<Maybe<CartSeller>>>;
  couponCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  discountCents?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  items?: Maybe<Array<Maybe<CartItem>>>;
  messageToGiftRecipient?: Maybe<Scalars['String']['output']>;
  messageToSeller?: Maybe<Scalars['String']['output']>;
  shippingCostCents?: Maybe<Scalars['Float']['output']>;
  subtotalCents?: Maybe<Scalars['Float']['output']>;
  taxTotalCents?: Maybe<Scalars['Float']['output']>;
  totalCents?: Maybe<Scalars['Float']['output']>;
}

export interface CartAddress {
  __typename?: 'cartAddress';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CartCountry>;
  fullAddress?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  subaddress?: Maybe<Scalars['String']['output']>;
}

export interface CartAddressInput {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  stateCode: Scalars['String']['input'];
  subaddress?: InputMaybe<Scalars['String']['input']>;
}

export interface CartCountry {
  __typename?: 'cartCountry';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
}

export interface CartItem {
  __typename?: 'cartItem';
  advert?: Maybe<Advert>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  discountCents?: Maybe<Scalars['Float']['output']>;
  hasFreeShippingDiscount?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  internationalShippingAvailable?: Maybe<Scalars['Boolean']['output']>;
  internationalShippingRequired?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  seller?: Maybe<SellerDetail>;
  shippingCostCents?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<CartItemStatus>;
  subtotalCents?: Maybe<Scalars['Float']['output']>;
  totalCents?: Maybe<Scalars['Float']['output']>;
  variant?: Maybe<AdvertVariant>;
}

export interface CartItemDeliveryMethodGroup {
  __typename?: 'cartItemDeliveryMethodGroup';
  deliveryMethod?: Maybe<DeliveryMethod>;
  discountCents?: Maybe<Scalars['Float']['output']>;
  shippingCostCents?: Maybe<Scalars['Float']['output']>;
  shippingDescription?: Maybe<Scalars['String']['output']>;
  subtotalCents?: Maybe<Scalars['Float']['output']>;
  taxTotalCents?: Maybe<Scalars['Float']['output']>;
  totalCents?: Maybe<Scalars['Float']['output']>;
}

export interface CartMetadata {
  address?: InputMaybe<CartAddressInput>;
  billingAddress?: InputMaybe<CartAddressInput>;
  billingEmailAddress?: InputMaybe<Scalars['String']['input']>;
  billingFirstName?: InputMaybe<Scalars['String']['input']>;
  billingPhone?: InputMaybe<Scalars['String']['input']>;
  billingSurname?: InputMaybe<Scalars['String']['input']>;
  cartId?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  recipientFirstName?: InputMaybe<Scalars['String']['input']>;
  recipientMobile?: InputMaybe<Scalars['String']['input']>;
  recipientOver18Confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  recipientSurname?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
}

export interface CartMetadataCoupon {
  address?: InputMaybe<CartAddressInput>;
  billingAddress?: InputMaybe<CartAddressInput>;
  billingEmailAddress?: InputMaybe<Scalars['String']['input']>;
  billingFirstName?: InputMaybe<Scalars['String']['input']>;
  billingPhone?: InputMaybe<Scalars['String']['input']>;
  billingSurname?: InputMaybe<Scalars['String']['input']>;
  cartId?: InputMaybe<Scalars['String']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  recipientFirstName?: InputMaybe<Scalars['String']['input']>;
  recipientMobile?: InputMaybe<Scalars['String']['input']>;
  recipientOver18Confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  recipientSurname?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
}

export type CartResult = Cart | Error;

export interface CartSeller {
  __typename?: 'cartSeller';
  baseDomesticShippingCost?: Maybe<Scalars['Float']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  cartItemDeliveryMethodGroup?: Maybe<Array<Maybe<CartItemDeliveryMethodGroup>>>;
  domesticShippingFreeThreshold?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
}

export interface Category {
  __typename?: 'category';
  category_availableForBeta?: Maybe<Scalars['Boolean']['output']>;
  category_categoryId?: Maybe<Scalars['String']['output']>;
  category_categorylevel?: Maybe<Scalars['Int']['output']>;
  category_friendlyName?: Maybe<Scalars['String']['output']>;
  category_hideFromMenu?: Maybe<Scalars['Boolean']['output']>;
  category_iconUrl?: Maybe<Scalars['String']['output']>;
  category_level1?: Maybe<Scalars['String']['output']>;
  category_level2?: Maybe<Scalars['String']['output']>;
  category_level3?: Maybe<Scalars['String']['output']>;
  category_mainCategoryBannerColor?: Maybe<Scalars['String']['output']>;
  category_mainCategoryBannerUrl?: Maybe<Scalars['String']['output']>;
  category_metadataDescription?: Maybe<Scalars['String']['output']>;
  category_metadataTitle?: Maybe<Scalars['String']['output']>;
  category_name?: Maybe<Scalars['String']['output']>;
  category_order?: Maybe<Scalars['Int']['output']>;
  category_productCount?: Maybe<Scalars['Int']['output']>;
  category_richDescription?: Maybe<Scalars['String']['output']>;
  category_seoKeywords?: Maybe<Scalars['String']['output']>;
  category_subCategoryBannerColor?: Maybe<Scalars['String']['output']>;
  category_subCategoryBannerUrl?: Maybe<Scalars['String']['output']>;
  category_thumbnailUrl?: Maybe<Scalars['String']['output']>;
  category_tier1?: Maybe<Scalars['Boolean']['output']>;
  category_tileUrl?: Maybe<Scalars['String']['output']>;
}

export type CategoryByLevelNameResult = Category | Error;

export enum CategoryContext {
  CategoryTopLevel1 = 'categoryTopLevel1',
  ContinueBrowsing = 'continueBrowsing',
  MainMenu = 'mainMenu',
  ShopAndSave = 'shopAndSave',
  SpecialsLove = 'specialsLove',
  SubCategories = 'subCategories'
}

export interface CategoryList {
  __typename?: 'categoryList';
  items?: Maybe<Array<Maybe<Category>>>;
  total?: Maybe<Scalars['Int']['output']>;
}

export type CategoryListResult = CategoryList | Error;

export interface CheckoutWithRedirectionResponse {
  __typename?: 'checkoutWithRedirectionResponse';
  order?: Maybe<Order>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
}

export type CheckoutWithRedirectionResult = CheckoutWithRedirectionResponse | Error;

export type Content = Error | Product | ProductGroup | Retailer;

export interface CustomAttribute {
  __typename?: 'customAttribute';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
}

export interface DeletedUser {
  __typename?: 'deletedUser';
  deletedUserId: Scalars['String']['output'];
}

export type DeletedUserResult = DeletedUser | Error;

export enum EntityType {
  Product = 'product',
  ProductGroup = 'productGroup',
  Retailer = 'retailer'
}

export interface Error {
  __typename?: 'error';
  aws_trace_id?: Maybe<Scalars['String']['output']>;
  error_code?: Maybe<Scalars['String']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
}

export interface Features {
  __typename?: 'features';
  config?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
}

export type FeaturesResult = Error | Features;

export interface Geoloc {
  __typename?: 'geoloc';
  lat?: Maybe<Scalars['Float']['output']>;
  lon?: Maybe<Scalars['Float']['output']>;
}

export interface InputCheckoutAttributes {
  updateUserProfile?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface InputCheckoutParams {
  checkoutAttributes?: InputMaybe<InputCheckoutAttributes>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  gaAttributes?: InputMaybe<GoogleAnalyticsInput>;
  paymentProviderAttributes: InputCheckoutProvider;
  riskifiedAttributes?: InputMaybe<RiskifiedSourceProviderInput>;
  shopbackAttributes?: InputMaybe<ShopbackInput>;
}

export interface InputCheckoutProvider {
  deviceData?: InputMaybe<Scalars['String']['input']>;
  paymentNonce: Scalars['String']['input'];
  paymentProvider: PaymentProvider;
  providerParams?: InputMaybe<Scalars['String']['input']>;
  redirectCancellationUrl?: InputMaybe<Scalars['String']['input']>;
  redirectConfirmationUrl?: InputMaybe<Scalars['String']['input']>;
}

export interface InputGeoloc {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lon?: InputMaybe<Scalars['Float']['input']>;
}

export interface InputNotificationPreferences {
  enableAppNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  enableEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  enableNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  enableSMSNotifications?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface InputProductFilters {
  filterbyBrands?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterbyBuyNow?: InputMaybe<Scalars['Boolean']['input']>;
  filterbyCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterbyPages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterbyPrice?: InputMaybe<Minmax>;
  filterbyProductGroups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterbyProductName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterbyProducts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterbyRetailers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterbySavingsPercentage?: InputMaybe<Scalars['Int']['input']>;
}

export interface InputProductGroupFilters {
  filterbyProductGroupName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface InputUser {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isOver18?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<InputUserPreferences>;
  signupCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  signupDate?: InputMaybe<Scalars['String']['input']>;
}

export interface InputUserPreferences {
  brands?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notifications?: InputMaybe<InputNotificationPreferences>;
  postCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  retailers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Inventory {
  __typename?: 'inventory';
  countOnHand?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  infiniteQuantity?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  salePrice?: Maybe<Scalars['Float']['output']>;
  seller?: Maybe<SellerDetail>;
}

export type InventoryResult = Error | InventoryStatus;

export interface InventoryStatus {
  __typename?: 'inventoryStatus';
  available?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
}

export interface Invoice {
  __typename?: 'invoice';
  buyerBillingAddress?: Maybe<CartAddress>;
  buyerEmailAddress?: Maybe<Scalars['String']['output']>;
  buyerFirstName?: Maybe<Scalars['String']['output']>;
  buyerMessageToSeller?: Maybe<Scalars['String']['output']>;
  buyerPhone?: Maybe<Scalars['String']['output']>;
  buyerSurname?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lineItems?: Maybe<Array<Maybe<LineItem>>>;
  paidAt?: Maybe<Scalars['String']['output']>;
  paymentInstrumentType?: Maybe<Scalars['String']['output']>;
  pdfLink?: Maybe<Scalars['String']['output']>;
  retailer?: Maybe<RetailerDetail>;
  seller?: Maybe<SellerDetail>;
  shippingCostCents?: Maybe<Scalars['Float']['output']>;
  shippingDescription?: Maybe<Scalars['String']['output']>;
  shippingFromLocationMessage?: Maybe<Scalars['String']['output']>;
  statusFlags?: Maybe<Array<Maybe<InvoiceStatus>>>;
  subtotalCents?: Maybe<Scalars['Float']['output']>;
  taxShippingCents?: Maybe<Scalars['Float']['output']>;
  taxTotalCents?: Maybe<Scalars['Float']['output']>;
  totalCents?: Maybe<Scalars['Float']['output']>;
}

export interface LineItem {
  __typename?: 'lineItem';
  advertCode?: Maybe<Scalars['String']['output']>;
  advertId?: Maybe<Scalars['String']['output']>;
  advertTitle?: Maybe<Scalars['String']['output']>;
  discountCents?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  inventory?: Maybe<Inventory>;
  postageCents?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quantityAwaitingDispatch?: Maybe<Scalars['Int']['output']>;
  shipments?: Maybe<Array<Maybe<Shipment>>>;
  statusFull?: Maybe<LineItemStatus>;
  subtotalCents?: Maybe<Scalars['Float']['output']>;
  taxTotalCents?: Maybe<Scalars['Float']['output']>;
  totalCents?: Maybe<Scalars['Float']['output']>;
  variantBarcode?: Maybe<Scalars['String']['output']>;
  variantId?: Maybe<Scalars['String']['output']>;
  variantName?: Maybe<Scalars['String']['output']>;
  variantSku?: Maybe<Scalars['String']['output']>;
}

export interface Location {
  __typename?: 'location';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressLine3?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  geopoint?: Maybe<Geoloc>;
  locationId?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  storeHours?: Maybe<StoreHours>;
  suburb?: Maybe<Scalars['String']['output']>;
}

export interface Measurement {
  __typename?: 'measurement';
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
}

export interface Minmax {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
}

export interface NotificationPreferences {
  __typename?: 'notificationPreferences';
  enableAppNotifications?: Maybe<Scalars['Boolean']['output']>;
  enableEmailNotifications?: Maybe<Scalars['Boolean']['output']>;
  enableNotifications?: Maybe<Scalars['Boolean']['output']>;
  enableSMSNotifications?: Maybe<Scalars['Boolean']['output']>;
}

export interface Order {
  __typename?: 'order';
  address?: Maybe<CartAddress>;
  aggregateInvoiceStatusFinal?: Maybe<Scalars['Boolean']['output']>;
  billingAddress?: Maybe<CartAddress>;
  billingCompanyName?: Maybe<Scalars['String']['output']>;
  billingEmailAddress?: Maybe<Scalars['String']['output']>;
  billingFirstName?: Maybe<Scalars['String']['output']>;
  billingPhone?: Maybe<Scalars['String']['output']>;
  billingSurname?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  discountCents?: Maybe<Scalars['Float']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  expectedDeliveryDate?: Maybe<Scalars['String']['output']>;
  expectedDeliverySlot?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  isGift?: Maybe<Scalars['Boolean']['output']>;
  messageToGiftRecipient?: Maybe<Scalars['String']['output']>;
  messageToSeller?: Maybe<Scalars['String']['output']>;
  paymentGatewayDetails?: Maybe<Scalars['String']['output']>;
  paymentInstrumentType?: Maybe<Scalars['String']['output']>;
  permalink?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  shippingCostCents?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<OrderStatus>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  subtotalCents?: Maybe<Scalars['Float']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  taxTotal?: Maybe<Scalars['Float']['output']>;
  taxTotalCents?: Maybe<Scalars['Float']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  totalCents?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
}

export interface OrderList {
  __typename?: 'orderList';
  items?: Maybe<Array<Maybe<Order>>>;
  total?: Maybe<Scalars['Int']['output']>;
}

export type OrderListResult = Error | OrderList;

export type OrderResult = Error | Order | UserActionError;

export interface PageDetails {
  __typename?: 'pageDetails';
  imageMap?: Maybe<Scalars['String']['output']>;
  onPage?: Maybe<Scalars['Int']['output']>;
  pageImage?: Maybe<Scalars['String']['output']>;
  productGroupId?: Maybe<Scalars['String']['output']>;
}

export interface PageLink {
  __typename?: 'pageLink';
  imagePath?: Maybe<Scalars['String']['output']>;
  pageNumber?: Maybe<Scalars['String']['output']>;
}

export interface PaymentToken {
  __typename?: 'paymentToken';
  paymentToken: Scalars['String']['output'];
}

export type PaymentTokenResult = Error | PaymentToken;

export interface ProcessPaymentGatewayRedirect {
  __typename?: 'processPaymentGatewayRedirect';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
}

export interface ProcessPaymentGatewayRedirectMutationInput {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paymentProviderRedirectConfirmationAttributes?: InputMaybe<RedirectConfirmationInput>;
}

export type ProcessPaymentGatewayRedirectResult = Error | ProcessPaymentGatewayRedirect;

export interface Product {
  __typename?: 'product';
  entityType?: Maybe<Scalars['String']['output']>;
  product_additionalImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  product_advertLookUp?: Maybe<Scalars['String']['output']>;
  product_availability?: Maybe<Scalars['String']['output']>;
  product_brand?: Maybe<Scalars['String']['output']>;
  product_brandId?: Maybe<Scalars['String']['output']>;
  product_buyNow?: Maybe<Scalars['Boolean']['output']>;
  product_categoryId?: Maybe<Scalars['String']['output']>;
  product_categoryName?: Maybe<Scalars['String']['output']>;
  product_categorylevel?: Maybe<Scalars['Int']['output']>;
  product_categorylevel1?: Maybe<Scalars['String']['output']>;
  product_categorylevel2?: Maybe<Scalars['String']['output']>;
  product_categorylevel3?: Maybe<Scalars['String']['output']>;
  product_categorylevel4?: Maybe<Scalars['String']['output']>;
  product_categorylevel5?: Maybe<Scalars['String']['output']>;
  product_categorylevel6?: Maybe<Scalars['String']['output']>;
  product_categorylevel7?: Maybe<Scalars['String']['output']>;
  product_channel?: Maybe<Scalars['String']['output']>;
  product_color?: Maybe<Scalars['String']['output']>;
  product_description?: Maybe<Scalars['String']['output']>;
  product_endDate?: Maybe<Scalars['String']['output']>;
  product_featured?: Maybe<Scalars['Boolean']['output']>;
  product_gender?: Maybe<Scalars['String']['output']>;
  product_gtin?: Maybe<Scalars['String']['output']>;
  product_hideDate?: Maybe<Scalars['Boolean']['output']>;
  product_id?: Maybe<Scalars['String']['output']>;
  product_imageMap?: Maybe<Scalars['String']['output']>;
  product_imageUrl?: Maybe<Scalars['String']['output']>;
  product_inWishList?: Maybe<Scalars['Boolean']['output']>;
  product_isDuplicate?: Maybe<Scalars['Boolean']['output']>;
  product_isHidden?: Maybe<Scalars['Boolean']['output']>;
  product_isPurchasableOnline?: Maybe<Scalars['Boolean']['output']>;
  product_itemGroupID?: Maybe<Scalars['String']['output']>;
  product_linkUrl?: Maybe<Scalars['String']['output']>;
  product_material?: Maybe<Scalars['String']['output']>;
  product_mpn?: Maybe<Scalars['String']['output']>;
  product_multiPrice?: Maybe<Scalars['Boolean']['output']>;
  product_multiVariant?: Maybe<Scalars['Boolean']['output']>;
  product_name?: Maybe<Scalars['String']['output']>;
  product_offerTitle?: Maybe<Scalars['String']['output']>;
  product_onPage?: Maybe<Scalars['Int']['output']>;
  product_pageDetails?: Maybe<Array<Maybe<PageDetails>>>;
  product_pageImage?: Maybe<Scalars['String']['output']>;
  product_pattern?: Maybe<Scalars['String']['output']>;
  product_price?: Maybe<Scalars['Float']['output']>;
  product_productGroup?: Maybe<ProductGroup>;
  product_productGroupId?: Maybe<Scalars['String']['output']>;
  product_productMeasurement?: Maybe<Array<Maybe<Measurement>>>;
  product_productType?: Maybe<Scalars['String']['output']>;
  product_retailer?: Maybe<Retailer>;
  product_retailerId?: Maybe<Scalars['String']['output']>;
  product_salePrice?: Maybe<Scalars['Float']['output']>;
  product_salePriceDescription?: Maybe<Scalars['String']['output']>;
  product_savingsAbsolute?: Maybe<Scalars['Float']['output']>;
  product_savingsPercentage?: Maybe<Scalars['Float']['output']>;
  product_shippingDescription?: Maybe<Scalars['String']['output']>;
  product_startDate?: Maybe<Scalars['String']['output']>;
  product_subBrand?: Maybe<Scalars['String']['output']>;
  product_subtitle?: Maybe<Scalars['String']['output']>;
  product_tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  product_termsAndConditions?: Maybe<Scalars['String']['output']>;
  product_title?: Maybe<Scalars['String']['output']>;
  product_uomDescription?: Maybe<Scalars['String']['output']>;
}

export type ProductDeliveryResult = Error | ProductDeliveryStatus;

export interface ProductDeliveryStatus {
  __typename?: 'productDeliveryStatus';
  items?: Maybe<Array<ProductItemDeliveryStatus>>;
}

export interface ProductGroup {
  __typename?: 'productGroup';
  entityType?: Maybe<Scalars['String']['output']>;
  productGroup_buyNow?: Maybe<Scalars['Boolean']['output']>;
  productGroup_displayName?: Maybe<Scalars['String']['output']>;
  productGroup_endDate?: Maybe<Scalars['String']['output']>;
  productGroup_forbiddenPostCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  productGroup_hideDate?: Maybe<Scalars['Boolean']['output']>;
  productGroup_instructions?: Maybe<Scalars['String']['output']>;
  productGroup_isBundle?: Maybe<Scalars['Boolean']['output']>;
  productGroup_isMarketplace?: Maybe<Scalars['Boolean']['output']>;
  productGroup_linkUrl?: Maybe<Scalars['String']['output']>;
  productGroup_metadata?: Maybe<Array<Maybe<ProductGroupMetadata>>>;
  productGroup_numberOfPages?: Maybe<Scalars['Int']['output']>;
  productGroup_pageLinks?: Maybe<Array<Maybe<PageLink>>>;
  productGroup_postcodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  productGroup_productGroupId?: Maybe<Scalars['String']['output']>;
  productGroup_productGroupImage?: Maybe<Scalars['String']['output']>;
  productGroup_productsTotal?: Maybe<Scalars['Int']['output']>;
  productGroup_publicationDate?: Maybe<Scalars['String']['output']>;
  productGroup_retailer?: Maybe<Retailer>;
  productGroup_retailerId?: Maybe<Scalars['String']['output']>;
  productGroup_startDate?: Maybe<Scalars['String']['output']>;
  productGroup_termsAndConditions?: Maybe<Scalars['String']['output']>;
  productGroup_thumbnailUrl?: Maybe<Scalars['String']['output']>;
  productGroup_type?: Maybe<ProductGroupType>;
}

export interface ProductGroupList {
  __typename?: 'productGroupList';
  items?: Maybe<Array<Maybe<ProductGroup>>>;
  total?: Maybe<Scalars['Int']['output']>;
}

export type ProductGroupListResult = Error | ProductGroupList;

export interface ProductGroupMetadata {
  __typename?: 'productGroupMetadata';
  productGroupMetadata_displayName?: Maybe<Scalars['String']['output']>;
  productGroupMetadata_imageMap?: Maybe<Scalars['String']['output']>;
  productGroupMetadata_imagePath?: Maybe<Scalars['String']['output']>;
  productGroupMetadata_linkToPage?: Maybe<Scalars['String']['output']>;
  productGroupMetadata_metaText?: Maybe<Scalars['String']['output']>;
  productGroupMetadata_metaUrl?: Maybe<Scalars['String']['output']>;
  productGroupMetadata_metadataId?: Maybe<Scalars['String']['output']>;
  productGroupMetadata_name?: Maybe<Scalars['String']['output']>;
  productGroupMetadata_offerId?: Maybe<Scalars['String']['output']>;
  productGroupMetadata_pageNo?: Maybe<Scalars['String']['output']>;
  productGroupMetadata_productGroupId?: Maybe<Scalars['String']['output']>;
  productGroupMetadata_type?: Maybe<Scalars['String']['output']>;
  productGroupMetadata_videoUrl?: Maybe<Scalars['String']['output']>;
}

export enum ProductGroupType {
  Catalogue = 'CATALOGUE',
  CataloguePurchasable = 'CATALOGUE_PURCHASABLE',
  CatalogueVirtual = 'CATALOGUE_VIRTUAL',
  Group = 'GROUP'
}

export interface ProductItemDeliveryStatus {
  __typename?: 'productItemDeliveryStatus';
  deliverable: Scalars['Boolean']['output'];
  productId: Scalars['Int']['output'];
}

export interface ProductList {
  __typename?: 'productList';
  brands?: Maybe<Array<Maybe<Brand>>>;
  items?: Maybe<Array<Maybe<Product>>>;
  productGroups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  produtGroupCount?: Maybe<Scalars['Int']['output']>;
  retailerCount?: Maybe<Scalars['Int']['output']>;
  retailers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  total?: Maybe<Scalars['Int']['output']>;
}

export type ProductListResult = Error | ProductList;

export interface ProductVariantImageList {
  __typename?: 'productVariantImageList';
  items?: Maybe<Array<Maybe<VariantImage>>>;
}

export type ProductVariantImageListResult = Error | ProductVariantImageList;

export interface Retailer {
  __typename?: 'retailer';
  entityType?: Maybe<Scalars['String']['output']>;
  retailer_availableForBeta?: Maybe<Scalars['Boolean']['output']>;
  retailer_colour?: Maybe<Scalars['String']['output']>;
  retailer_country?: Maybe<Scalars['String']['output']>;
  retailer_deliveryMethod?: Maybe<RetailerDeliveryMethod>;
  retailer_description?: Maybe<Scalars['String']['output']>;
  retailer_displayName?: Maybe<Scalars['String']['output']>;
  retailer_email?: Maybe<Scalars['AWSEmail']['output']>;
  retailer_id?: Maybe<Scalars['String']['output']>;
  retailer_lasooIt?: Maybe<Scalars['Boolean']['output']>;
  retailer_locations?: Maybe<Array<Maybe<Location>>>;
  retailer_logoUrl?: Maybe<Scalars['String']['output']>;
  retailer_logoUrlLarge?: Maybe<Scalars['String']['output']>;
  retailer_logoUrlSmall?: Maybe<Scalars['String']['output']>;
  retailer_metadataDescriptionProductGroup?: Maybe<Scalars['String']['output']>;
  retailer_metadataDescriptionRetailer?: Maybe<Scalars['String']['output']>;
  retailer_metadataTitleProductGroup?: Maybe<Scalars['String']['output']>;
  retailer_metadataTitleRetailer?: Maybe<Scalars['String']['output']>;
  retailer_name?: Maybe<Scalars['String']['output']>;
  retailer_requireOverAgeCheck?: Maybe<Scalars['Boolean']['output']>;
  retailer_shippingEstimationMessage?: Maybe<Scalars['String']['output']>;
  retailer_telephone?: Maybe<Scalars['String']['output']>;
  retailer_websiteURL?: Maybe<Scalars['String']['output']>;
}

export interface RetailerDetail {
  __typename?: 'retailerDetail';
  color?: Maybe<Scalars['String']['output']>;
  deliveryMethod?: Maybe<RetailerDeliveryMethod>;
  displayName?: Maybe<Scalars['String']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  logoUrlLarge?: Maybe<Scalars['String']['output']>;
  logoUrlSmall?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  requireOverAgeCheck?: Maybe<Scalars['Boolean']['output']>;
  retailerCategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  retailerId?: Maybe<Scalars['String']['output']>;
  shippingEstimationMessage?: Maybe<Scalars['String']['output']>;
  websiteURL?: Maybe<Scalars['String']['output']>;
}

export interface RetailerList {
  __typename?: 'retailerList';
  items?: Maybe<Array<Maybe<Retailer>>>;
  total?: Maybe<Scalars['Int']['output']>;
}

export type RetailerListResult = Error | RetailerList;

export interface SellerDetail {
  __typename?: 'sellerDetail';
  baseDomesticShippingCost?: Maybe<Scalars['Float']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  deliveryDetails?: Maybe<Scalars['String']['output']>;
  domesticShippingFreeThreshold?: Maybe<Scalars['Float']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mailToUrl?: Maybe<Scalars['String']['output']>;
  obscuredPhone?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  returnPolicy?: Maybe<Scalars['String']['output']>;
  sellerIsContactable?: Maybe<Scalars['Boolean']['output']>;
  servicePolicy?: Maybe<Scalars['String']['output']>;
  showPhoneNumber?: Maybe<Scalars['Boolean']['output']>;
  underAdDescription?: Maybe<Scalars['String']['output']>;
  underAdImpressum?: Maybe<Scalars['String']['output']>;
}

export interface Shipment {
  __typename?: 'shipment';
  carrier?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  dispatchedAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  trackingLink?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export interface StoreHours {
  __typename?: 'storeHours';
  friday?: Maybe<StoreHoursDay>;
  monday?: Maybe<StoreHoursDay>;
  saturday?: Maybe<StoreHoursDay>;
  sunday?: Maybe<StoreHoursDay>;
  thursday?: Maybe<StoreHoursDay>;
  tuesday?: Maybe<StoreHoursDay>;
  wednesday?: Maybe<StoreHoursDay>;
}

export interface StoreHoursDay {
  __typename?: 'storeHoursDay';
  closeHours: Scalars['String']['output'];
  startHours: Scalars['String']['output'];
}

export interface Success {
  __typename?: 'success';
  success?: Maybe<Scalars['Boolean']['output']>;
}

export interface SuccessBool {
  __typename?: 'successBool';
  isSuccess: Scalars['Boolean']['output'];
}

export interface User {
  __typename?: 'user';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  isOver18?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<UserPreferences>;
  signupCompleted?: Maybe<Scalars['Boolean']['output']>;
  signupDate?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
}

export interface UserActionError {
  __typename?: 'userActionError';
  error_message?: Maybe<Scalars['String']['output']>;
  error_title?: Maybe<Scalars['String']['output']>;
  navigate_to?: Maybe<Scalars['String']['output']>;
}

export interface UserPreferences {
  __typename?: 'userPreferences';
  brands?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  notifications?: Maybe<NotificationPreferences>;
  postCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  retailers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
}

export type UserResult = Error | User;

export interface V2SearchProductList {
  __typename?: 'v2SearchProductList';
  autocorrectedSearchTerms?: Maybe<Scalars['String']['output']>;
  brands?: Maybe<Array<Maybe<Brand>>>;
  items?: Maybe<Array<Maybe<Product>>>;
  total?: Maybe<Scalars['Int']['output']>;
}

export type V2SearchProductListResult = Error | V2SearchProductList;

export interface VariantImage {
  __typename?: 'variantImage';
  filename?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
}

export interface WishList {
  __typename?: 'wishList';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  products?: Maybe<Array<Maybe<Product>>>;
}

export interface WishLists {
  __typename?: 'wishLists';
  items?: Maybe<Array<Maybe<WishList>>>;
  total?: Maybe<Scalars['Int']['output']>;
}

export type WishListsResult = Error | WishLists;

export type AddItemToCartMutationVariables = Exact<{
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryMethod: DeliveryMethod;
  productId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  variantBarcode?: InputMaybe<Scalars['String']['input']>;
  variantId: Scalars['String']['input'];
  advertId: Scalars['String']['input'];
  cartId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddItemToCartMutation = { __typename?: 'Mutation', addItemToCart?: { __typename: 'cart', id?: string | null, billingCompanyName?: string | null, billingEmailAddress?: string | null, billingFirstName?: string | null, billingPhone?: string | null, billingSurname?: string | null, buyableQuantity?: number | null, messageToGiftRecipient?: string | null, messageToSeller?: string | null, shippingCostCents?: number | null, taxTotalCents?: number | null, createdAt?: string | null, couponCode?: string | null, discountCents?: number | null, subtotalCents?: number | null, totalCents?: number | null, cartSellers?: Array<{ __typename?: 'cartSeller', id?: string | null, baseDomesticShippingCost?: number | null, businessName?: string | null, domesticShippingFreeThreshold?: number | null, cartItemDeliveryMethodGroup?: Array<{ __typename?: 'cartItemDeliveryMethodGroup', deliveryMethod?: DeliveryMethod | null, discountCents?: number | null, shippingCostCents?: number | null, subtotalCents?: number | null, taxTotalCents?: number | null, totalCents?: number | null, shippingDescription?: string | null } | null> | null } | null> | null, address?: { __typename?: 'cartAddress', address?: string | null, city?: string | null, fullAddress?: string | null, postcode?: string | null, state?: string | null, subaddress?: string | null, country?: { __typename?: 'cartCountry', code?: string | null, name?: string | null } | null } | null, billingAddress?: { __typename?: 'cartAddress', address?: string | null, city?: string | null, fullAddress?: string | null, postcode?: string | null, state?: string | null, subaddress?: string | null, country?: { __typename?: 'cartCountry', code?: string | null, name?: string | null } | null } | null, items?: Array<{ __typename: 'cartItem', id?: string | null, deliveryMethod?: DeliveryMethod | null, discountCents?: number | null, hasFreeShippingDiscount?: boolean | null, internationalShippingAvailable?: boolean | null, internationalShippingRequired?: boolean | null, quantity?: number | null, shippingCostCents?: number | null, subtotalCents?: number | null, productId?: number | null, totalCents?: number | null, status?: CartItemStatus | null, seller?: { __typename?: 'sellerDetail', baseDomesticShippingCost?: number | null, businessName?: string | null, deliveryDetails?: string | null, domesticShippingFreeThreshold?: number | null, emailAddress?: string | null, id?: string | null, mailToUrl?: string | null, obscuredPhone?: string | null, phone?: string | null, returnPolicy?: string | null, sellerIsContactable?: boolean | null, servicePolicy?: string | null, showPhoneNumber?: boolean | null, underAdDescription?: string | null, underAdImpressum?: string | null } | null, advert?: { __typename?: 'advert', brand?: string | null, brandName?: string | null, category?: string | null, description?: string | null, displayImage?: string | null, editablePrice?: string | null, editableSalePrice?: string | null, fullTitle?: string | null, id?: string | null, sellerId?: string | null, title?: string | null, aoStockCodes?: Array<{ __typename: 'AoStock', key?: StateEnum | null, value?: number | null } | null> | null } | null, product?: { __typename: 'product', product_id?: string | null, product_price?: number | null, product_salePrice?: number | null, product_uomDescription?: string | null, product_description?: string | null, product_shippingDescription?: string | null, product_savingsPercentage?: number | null, product_buyNow?: boolean | null, product_name?: string | null, product_imageUrl?: string | null, product_hideDate?: boolean | null, product_endDate?: string | null, product_onPage?: number | null, product_inWishList?: boolean | null, product_imageMap?: string | null, product_isDuplicate?: boolean | null, product_isHidden?: boolean | null, product_startDate?: string | null, product_savingsAbsolute?: number | null, product_linkUrl?: string | null, product_title?: string | null, product_categorylevel1?: string | null, product_categorylevel2?: string | null, product_categorylevel3?: string | null, product_categorylevel?: number | null, product_retailerId?: string | null, product_additionalImageUrl?: Array<string | null> | null, product_productGroupId?: string | null, product_categoryId?: string | null, product_brand?: string | null, product_productGroup?: { __typename?: 'productGroup', productGroup_type?: ProductGroupType | null, productGroup_displayName?: string | null, productGroup_forbiddenPostCodes?: Array<string | null> | null } | null, product_retailer?: { __typename?: 'retailer', retailer_colour?: string | null, retailer_logoUrl?: string | null, retailer_id?: string | null, retailer_displayName?: string | null, retailer_logoUrlSmall?: string | null, retailer_logoUrlLarge?: string | null, retailer_requireOverAgeCheck?: boolean | null, retailer_metadataTitleRetailer?: string | null, retailer_metadataDescriptionRetailer?: string | null, retailer_metadataTitleProductGroup?: string | null, retailer_metadataDescriptionProductGroup?: string | null, retailer_websiteURL?: string | null, retailer_deliveryMethod?: RetailerDeliveryMethod | null, retailer_shippingEstimationMessage?: string | null } | null } | null, variant?: { __typename?: 'advertVariant', available?: boolean | null, buyable?: boolean | null, countOnHand?: number | null, infiniteQuantity?: boolean | null, editablePrice?: number | null, editableSalePrice?: number | null, id?: string | null, imageUrls?: Array<string | null> | null, label?: string | null, published?: boolean | null, recommendedRetailPrice?: number | null, sku?: string | null, wholesalePrice?: string | null } | null } | null> | null } | { __typename: 'error', error_code?: string | null, error_message?: string | null } | null };

export type AddToWishListMutationVariables = Exact<{
  productId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddToWishListMutation = { __typename?: 'Mutation', addToWishList?: { __typename?: 'error' } | { __typename: 'wishLists', total?: number | null, items?: Array<{ __typename: 'wishList', id?: string | null, name?: string | null, productIds?: Array<string | null> | null } | null> | null } | null };

export type DeleteItemFromCartMutationVariables = Exact<{
  id: Scalars['String']['input'];
  cartId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteItemFromCartMutation = { __typename?: 'Mutation', deleteItemFromCart?: { __typename: 'cart', id?: string | null, billingCompanyName?: string | null, billingEmailAddress?: string | null, billingFirstName?: string | null, billingPhone?: string | null, billingSurname?: string | null, buyableQuantity?: number | null, messageToGiftRecipient?: string | null, messageToSeller?: string | null, shippingCostCents?: number | null, taxTotalCents?: number | null, createdAt?: string | null, couponCode?: string | null, discountCents?: number | null, subtotalCents?: number | null, totalCents?: number | null, cartSellers?: Array<{ __typename?: 'cartSeller', id?: string | null, baseDomesticShippingCost?: number | null, businessName?: string | null, domesticShippingFreeThreshold?: number | null, cartItemDeliveryMethodGroup?: Array<{ __typename?: 'cartItemDeliveryMethodGroup', deliveryMethod?: DeliveryMethod | null, discountCents?: number | null, shippingCostCents?: number | null, subtotalCents?: number | null, taxTotalCents?: number | null, totalCents?: number | null, shippingDescription?: string | null } | null> | null } | null> | null, address?: { __typename?: 'cartAddress', address?: string | null, city?: string | null, fullAddress?: string | null, postcode?: string | null, state?: string | null, subaddress?: string | null, country?: { __typename?: 'cartCountry', code?: string | null, name?: string | null } | null } | null, billingAddress?: { __typename?: 'cartAddress', address?: string | null, city?: string | null, fullAddress?: string | null, postcode?: string | null, state?: string | null, subaddress?: string | null, country?: { __typename?: 'cartCountry', code?: string | null, name?: string | null } | null } | null, items?: Array<{ __typename: 'cartItem', id?: string | null, deliveryMethod?: DeliveryMethod | null, discountCents?: number | null, hasFreeShippingDiscount?: boolean | null, internationalShippingAvailable?: boolean | null, internationalShippingRequired?: boolean | null, quantity?: number | null, shippingCostCents?: number | null, subtotalCents?: number | null, productId?: number | null, totalCents?: number | null, status?: CartItemStatus | null, seller?: { __typename?: 'sellerDetail', baseDomesticShippingCost?: number | null, businessName?: string | null, deliveryDetails?: string | null, domesticShippingFreeThreshold?: number | null, emailAddress?: string | null, id?: string | null, mailToUrl?: string | null, obscuredPhone?: string | null, phone?: string | null, returnPolicy?: string | null, sellerIsContactable?: boolean | null, servicePolicy?: string | null, showPhoneNumber?: boolean | null, underAdDescription?: string | null, underAdImpressum?: string | null } | null, advert?: { __typename?: 'advert', brand?: string | null, brandName?: string | null, category?: string | null, description?: string | null, displayImage?: string | null, editablePrice?: string | null, editableSalePrice?: string | null, fullTitle?: string | null, id?: string | null, sellerId?: string | null, title?: string | null, aoStockCodes?: Array<{ __typename: 'AoStock', key?: StateEnum | null, value?: number | null } | null> | null } | null, product?: { __typename: 'product', product_id?: string | null, product_price?: number | null, product_salePrice?: number | null, product_uomDescription?: string | null, product_description?: string | null, product_shippingDescription?: string | null, product_savingsPercentage?: number | null, product_buyNow?: boolean | null, product_name?: string | null, product_imageUrl?: string | null, product_hideDate?: boolean | null, product_endDate?: string | null, product_onPage?: number | null, product_inWishList?: boolean | null, product_imageMap?: string | null, product_isDuplicate?: boolean | null, product_isHidden?: boolean | null, product_startDate?: string | null, product_savingsAbsolute?: number | null, product_linkUrl?: string | null, product_title?: string | null, product_categorylevel1?: string | null, product_categorylevel2?: string | null, product_categorylevel3?: string | null, product_categorylevel?: number | null, product_retailerId?: string | null, product_additionalImageUrl?: Array<string | null> | null, product_productGroupId?: string | null, product_categoryId?: string | null, product_brand?: string | null, product_productGroup?: { __typename?: 'productGroup', productGroup_type?: ProductGroupType | null, productGroup_displayName?: string | null, productGroup_forbiddenPostCodes?: Array<string | null> | null } | null, product_retailer?: { __typename?: 'retailer', retailer_colour?: string | null, retailer_logoUrl?: string | null, retailer_id?: string | null, retailer_displayName?: string | null, retailer_logoUrlSmall?: string | null, retailer_logoUrlLarge?: string | null, retailer_requireOverAgeCheck?: boolean | null, retailer_metadataTitleRetailer?: string | null, retailer_metadataDescriptionRetailer?: string | null, retailer_metadataTitleProductGroup?: string | null, retailer_metadataDescriptionProductGroup?: string | null, retailer_websiteURL?: string | null, retailer_deliveryMethod?: RetailerDeliveryMethod | null, retailer_shippingEstimationMessage?: string | null } | null } | null, variant?: { __typename?: 'advertVariant', available?: boolean | null, buyable?: boolean | null, countOnHand?: number | null, infiniteQuantity?: boolean | null, editablePrice?: number | null, editableSalePrice?: number | null, id?: string | null, imageUrls?: Array<string | null> | null, label?: string | null, published?: boolean | null, recommendedRetailPrice?: number | null, sku?: string | null, wholesalePrice?: string | null } | null } | null> | null } | { __typename: 'error', error_code?: string | null, error_message?: string | null } | null };

export type DeleteUserMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser?: { __typename: 'deletedUser', deletedUserId: string } | { __typename: 'error', error_message?: string | null, error_code?: string | null } | null };

export type PlaceOrderCheckoutMutationVariables = Exact<{
  params: InputCheckoutParams;
  cartId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PlaceOrderCheckoutMutation = { __typename?: 'Mutation', checkout?: { __typename: 'error', error_code?: string | null, error_message?: string | null } | { __typename: 'order', aggregateInvoiceStatusFinal?: boolean | null, billingCompanyName?: string | null, billingEmailAddress?: string | null, billingFirstName?: string | null, billingPhone?: string | null, billingSurname?: string | null, companyName?: string | null, createdAt?: string | null, discountCents?: number | null, emailAddress?: string | null, expectedDeliveryDate?: string | null, expectedDeliverySlot?: string | null, firstName?: string | null, id?: string | null, isGift?: boolean | null, messageToGiftRecipient?: string | null, messageToSeller?: string | null, paymentGatewayDetails?: string | null, paymentInstrumentType?: string | null, permalink?: string | null, phone?: string | null, shippingCostCents?: number | null, status?: OrderStatus | null, subtotal?: number | null, subtotalCents?: number | null, surname?: string | null, taxTotal?: number | null, taxTotalCents?: number | null, token?: string | null, total?: number | null, totalCents?: number | null, updatedAt?: string | null, invoices?: Array<{ __typename?: 'invoice', buyerEmailAddress?: string | null, buyerFirstName?: string | null, buyerMessageToSeller?: string | null, buyerPhone?: string | null, buyerSurname?: string | null, id?: string | null, paidAt?: string | null, paymentInstrumentType?: string | null, pdfLink?: string | null, shippingCostCents?: number | null, shippingDescription?: string | null, shippingFromLocationMessage?: string | null, statusFlags?: Array<InvoiceStatus | null> | null, subtotalCents?: number | null, taxShippingCents?: number | null, taxTotalCents?: number | null, totalCents?: number | null, buyerBillingAddress?: { __typename?: 'cartAddress', address?: string | null, city?: string | null, fullAddress?: string | null, postcode?: string | null, state?: string | null, subaddress?: string | null, country?: { __typename?: 'cartCountry', code?: string | null, name?: string | null } | null } | null, lineItems?: Array<{ __typename?: 'lineItem', advertCode?: string | null, advertId?: string | null, advertTitle?: string | null, discountCents?: number | null, id?: string | null, image?: string | null, postageCents?: number | null, quantity?: number | null, quantityAwaitingDispatch?: number | null, statusFull?: LineItemStatus | null, subtotalCents?: number | null, taxTotalCents?: number | null, totalCents?: number | null, variantBarcode?: string | null, variantId?: string | null, variantName?: string | null, variantSku?: string | null, shipments?: Array<{ __typename?: 'shipment', carrier?: string | null, createdAt?: string | null, dispatchedAt?: string | null, id?: string | null, trackingLink?: string | null, trackingNumber?: string | null, updatedAt?: string | null } | null> | null } | null> | null, seller?: { __typename?: 'sellerDetail', baseDomesticShippingCost?: number | null, businessName?: string | null, deliveryDetails?: string | null, domesticShippingFreeThreshold?: number | null, emailAddress?: string | null, id?: string | null, mailToUrl?: string | null, obscuredPhone?: string | null, phone?: string | null, returnPolicy?: string | null, sellerIsContactable?: boolean | null, servicePolicy?: string | null, showPhoneNumber?: boolean | null, underAdDescription?: string | null, underAdImpressum?: string | null } | null, retailer?: { __typename?: 'retailerDetail', displayName?: string | null, isPublished?: boolean | null, color?: string | null, logoUrl?: string | null, logoUrlLarge?: string | null, logoUrlSmall?: string | null, name?: string | null, retailerCategories?: Array<string | null> | null, retailerId?: string | null, shippingEstimationMessage?: string | null, websiteURL?: string | null } | null } | null> | null } | { __typename: 'userActionError', error_message?: string | null, error_title?: string | null, navigate_to?: string | null } | null };

export type PlaceOrderCheckoutWithRedirectMutationVariables = Exact<{
  params: InputCheckoutParams;
  cartId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PlaceOrderCheckoutWithRedirectMutation = { __typename?: 'Mutation', checkoutWithRedirection?: { __typename: 'checkoutWithRedirectionResponse', redirectUrl?: string | null, order?: { __typename: 'order', aggregateInvoiceStatusFinal?: boolean | null, billingCompanyName?: string | null, billingEmailAddress?: string | null, billingFirstName?: string | null, billingPhone?: string | null, billingSurname?: string | null, companyName?: string | null, createdAt?: string | null, discountCents?: number | null, emailAddress?: string | null, expectedDeliveryDate?: string | null, expectedDeliverySlot?: string | null, firstName?: string | null, id?: string | null, isGift?: boolean | null, messageToGiftRecipient?: string | null, messageToSeller?: string | null, paymentGatewayDetails?: string | null, paymentInstrumentType?: string | null, permalink?: string | null, phone?: string | null, shippingCostCents?: number | null, status?: OrderStatus | null, subtotal?: number | null, subtotalCents?: number | null, surname?: string | null, taxTotal?: number | null, taxTotalCents?: number | null, token?: string | null, total?: number | null, totalCents?: number | null, updatedAt?: string | null, invoices?: Array<{ __typename?: 'invoice', buyerEmailAddress?: string | null, buyerFirstName?: string | null, buyerMessageToSeller?: string | null, buyerPhone?: string | null, buyerSurname?: string | null, id?: string | null, paidAt?: string | null, paymentInstrumentType?: string | null, pdfLink?: string | null, shippingCostCents?: number | null, shippingDescription?: string | null, shippingFromLocationMessage?: string | null, statusFlags?: Array<InvoiceStatus | null> | null, subtotalCents?: number | null, taxShippingCents?: number | null, taxTotalCents?: number | null, totalCents?: number | null, buyerBillingAddress?: { __typename?: 'cartAddress', address?: string | null, city?: string | null, fullAddress?: string | null, postcode?: string | null, state?: string | null, subaddress?: string | null, country?: { __typename?: 'cartCountry', code?: string | null, name?: string | null } | null } | null, lineItems?: Array<{ __typename?: 'lineItem', advertCode?: string | null, advertId?: string | null, advertTitle?: string | null, discountCents?: number | null, id?: string | null, image?: string | null, postageCents?: number | null, quantity?: number | null, quantityAwaitingDispatch?: number | null, statusFull?: LineItemStatus | null, subtotalCents?: number | null, taxTotalCents?: number | null, totalCents?: number | null, variantBarcode?: string | null, variantId?: string | null, variantName?: string | null, variantSku?: string | null, shipments?: Array<{ __typename?: 'shipment', carrier?: string | null, createdAt?: string | null, dispatchedAt?: string | null, id?: string | null, trackingLink?: string | null, trackingNumber?: string | null, updatedAt?: string | null } | null> | null } | null> | null, seller?: { __typename?: 'sellerDetail', baseDomesticShippingCost?: number | null, businessName?: string | null, deliveryDetails?: string | null, domesticShippingFreeThreshold?: number | null, emailAddress?: string | null, id?: string | null, mailToUrl?: string | null, obscuredPhone?: string | null, phone?: string | null, returnPolicy?: string | null, sellerIsContactable?: boolean | null, servicePolicy?: string | null, showPhoneNumber?: boolean | null, underAdDescription?: string | null, underAdImpressum?: string | null } | null, retailer?: { __typename?: 'retailerDetail', displayName?: string | null, isPublished?: boolean | null, color?: string | null, logoUrl?: string | null, logoUrlLarge?: string | null, logoUrlSmall?: string | null, name?: string | null, retailerCategories?: Array<string | null> | null, retailerId?: string | null, shippingEstimationMessage?: string | null, websiteURL?: string | null } | null } | null> | null } | null } | { __typename: 'error', error_code?: string | null, error_message?: string | null } | null };

export type ProcessPaymentGatewayRedirectMutationVariables = Exact<{
  input: ProcessPaymentGatewayRedirectMutationInput;
}>;


export type ProcessPaymentGatewayRedirectMutation = { __typename?: 'Mutation', processPaymentGatewayRedirect?: { __typename: 'error', error_code?: string | null, error_message?: string | null } | { __typename: 'processPaymentGatewayRedirect', clientMutationId?: string | null, order?: { __typename?: 'order', aggregateInvoiceStatusFinal?: boolean | null, billingCompanyName?: string | null, billingEmailAddress?: string | null, billingFirstName?: string | null, billingPhone?: string | null, billingSurname?: string | null, companyName?: string | null, createdAt?: string | null, discountCents?: number | null, emailAddress?: string | null, expectedDeliveryDate?: string | null, expectedDeliverySlot?: string | null, firstName?: string | null, id?: string | null, isGift?: boolean | null, messageToGiftRecipient?: string | null, messageToSeller?: string | null, paymentGatewayDetails?: string | null, paymentInstrumentType?: string | null, permalink?: string | null, phone?: string | null, shippingCostCents?: number | null, status?: OrderStatus | null, subtotal?: number | null, subtotalCents?: number | null, surname?: string | null, taxTotal?: number | null, taxTotalCents?: number | null, token?: string | null, total?: number | null, totalCents?: number | null, updatedAt?: string | null, invoices?: Array<{ __typename?: 'invoice', buyerEmailAddress?: string | null, buyerFirstName?: string | null, buyerMessageToSeller?: string | null, buyerPhone?: string | null, buyerSurname?: string | null, id?: string | null, paidAt?: string | null, paymentInstrumentType?: string | null, pdfLink?: string | null, shippingCostCents?: number | null, shippingDescription?: string | null, shippingFromLocationMessage?: string | null, statusFlags?: Array<InvoiceStatus | null> | null, subtotalCents?: number | null, taxShippingCents?: number | null, taxTotalCents?: number | null, totalCents?: number | null, buyerBillingAddress?: { __typename?: 'cartAddress', address?: string | null, city?: string | null, fullAddress?: string | null, postcode?: string | null, state?: string | null, subaddress?: string | null, country?: { __typename?: 'cartCountry', code?: string | null, name?: string | null } | null } | null, lineItems?: Array<{ __typename?: 'lineItem', advertCode?: string | null, advertId?: string | null, advertTitle?: string | null, discountCents?: number | null, id?: string | null, image?: string | null, postageCents?: number | null, quantity?: number | null, quantityAwaitingDispatch?: number | null, statusFull?: LineItemStatus | null, subtotalCents?: number | null, taxTotalCents?: number | null, totalCents?: number | null, variantBarcode?: string | null, variantId?: string | null, variantName?: string | null, variantSku?: string | null, shipments?: Array<{ __typename?: 'shipment', carrier?: string | null, createdAt?: string | null, dispatchedAt?: string | null, id?: string | null, trackingLink?: string | null, trackingNumber?: string | null, updatedAt?: string | null } | null> | null } | null> | null, seller?: { __typename?: 'sellerDetail', baseDomesticShippingCost?: number | null, businessName?: string | null, deliveryDetails?: string | null, domesticShippingFreeThreshold?: number | null, emailAddress?: string | null, id?: string | null, mailToUrl?: string | null, obscuredPhone?: string | null, phone?: string | null, returnPolicy?: string | null, sellerIsContactable?: boolean | null, servicePolicy?: string | null, showPhoneNumber?: boolean | null, underAdDescription?: string | null, underAdImpressum?: string | null } | null, retailer?: { __typename?: 'retailerDetail', displayName?: string | null, isPublished?: boolean | null, color?: string | null, logoUrl?: string | null, logoUrlLarge?: string | null, logoUrlSmall?: string | null, name?: string | null, retailerCategories?: Array<string | null> | null, retailerId?: string | null, shippingEstimationMessage?: string | null, websiteURL?: string | null } | null } | null> | null } | null } | null };

export type RemoveFromWishListMutationVariables = Exact<{
  productId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveFromWishListMutation = { __typename?: 'Mutation', removeFromWishList?: { __typename?: 'error' } | { __typename: 'wishLists', total?: number | null, items?: Array<{ __typename: 'wishList', id?: string | null, name?: string | null, productIds?: Array<string | null> | null } | null> | null } | null };

export type SaveUserProfileMutationVariables = Exact<{
  inputUser?: InputMaybe<InputUser>;
}>;


export type SaveUserProfileMutation = { __typename?: 'Mutation', saveUserProfile?: { __typename?: 'error' } | { __typename: 'user', mobile?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, isOver18?: boolean | null, preferences?: { __typename: 'userPreferences', postCodes?: Array<string | null> | null, retailers?: Array<string | null> | null, categories?: Array<string | null> | null, brands?: Array<string | null> | null, notifications?: { __typename?: 'notificationPreferences', enableNotifications?: boolean | null, enableAppNotifications?: boolean | null, enableEmailNotifications?: boolean | null, enableSMSNotifications?: boolean | null } | null } | null } | null };

export type UpdateCartItemMutationVariables = Exact<{
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryMethod?: InputMaybe<DeliveryMethod>;
  id: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  advertId: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
  variantId: Scalars['String']['input'];
  cartId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCartItemMutation = { __typename?: 'Mutation', updateCartItem?: { __typename: 'cart', id?: string | null, billingCompanyName?: string | null, billingEmailAddress?: string | null, billingFirstName?: string | null, billingPhone?: string | null, billingSurname?: string | null, buyableQuantity?: number | null, messageToGiftRecipient?: string | null, messageToSeller?: string | null, shippingCostCents?: number | null, taxTotalCents?: number | null, createdAt?: string | null, couponCode?: string | null, discountCents?: number | null, subtotalCents?: number | null, totalCents?: number | null, cartSellers?: Array<{ __typename?: 'cartSeller', id?: string | null, baseDomesticShippingCost?: number | null, businessName?: string | null, domesticShippingFreeThreshold?: number | null, cartItemDeliveryMethodGroup?: Array<{ __typename?: 'cartItemDeliveryMethodGroup', deliveryMethod?: DeliveryMethod | null, discountCents?: number | null, shippingCostCents?: number | null, subtotalCents?: number | null, taxTotalCents?: number | null, totalCents?: number | null, shippingDescription?: string | null } | null> | null } | null> | null, address?: { __typename?: 'cartAddress', address?: string | null, city?: string | null, fullAddress?: string | null, postcode?: string | null, state?: string | null, subaddress?: string | null, country?: { __typename?: 'cartCountry', code?: string | null, name?: string | null } | null } | null, billingAddress?: { __typename?: 'cartAddress', address?: string | null, city?: string | null, fullAddress?: string | null, postcode?: string | null, state?: string | null, subaddress?: string | null, country?: { __typename?: 'cartCountry', code?: string | null, name?: string | null } | null } | null, items?: Array<{ __typename: 'cartItem', id?: string | null, deliveryMethod?: DeliveryMethod | null, discountCents?: number | null, hasFreeShippingDiscount?: boolean | null, internationalShippingAvailable?: boolean | null, internationalShippingRequired?: boolean | null, quantity?: number | null, shippingCostCents?: number | null, subtotalCents?: number | null, productId?: number | null, totalCents?: number | null, status?: CartItemStatus | null, seller?: { __typename?: 'sellerDetail', baseDomesticShippingCost?: number | null, businessName?: string | null, deliveryDetails?: string | null, domesticShippingFreeThreshold?: number | null, emailAddress?: string | null, id?: string | null, mailToUrl?: string | null, obscuredPhone?: string | null, phone?: string | null, returnPolicy?: string | null, sellerIsContactable?: boolean | null, servicePolicy?: string | null, showPhoneNumber?: boolean | null, underAdDescription?: string | null, underAdImpressum?: string | null } | null, advert?: { __typename?: 'advert', brand?: string | null, brandName?: string | null, category?: string | null, description?: string | null, displayImage?: string | null, editablePrice?: string | null, editableSalePrice?: string | null, fullTitle?: string | null, id?: string | null, sellerId?: string | null, title?: string | null, aoStockCodes?: Array<{ __typename: 'AoStock', key?: StateEnum | null, value?: number | null } | null> | null } | null, product?: { __typename: 'product', product_id?: string | null, product_price?: number | null, product_salePrice?: number | null, product_uomDescription?: string | null, product_description?: string | null, product_shippingDescription?: string | null, product_savingsPercentage?: number | null, product_buyNow?: boolean | null, product_name?: string | null, product_imageUrl?: string | null, product_hideDate?: boolean | null, product_endDate?: string | null, product_onPage?: number | null, product_inWishList?: boolean | null, product_imageMap?: string | null, product_isDuplicate?: boolean | null, product_isHidden?: boolean | null, product_startDate?: string | null, product_savingsAbsolute?: number | null, product_linkUrl?: string | null, product_title?: string | null, product_categorylevel1?: string | null, product_categorylevel2?: string | null, product_categorylevel3?: string | null, product_categorylevel?: number | null, product_retailerId?: string | null, product_additionalImageUrl?: Array<string | null> | null, product_productGroupId?: string | null, product_categoryId?: string | null, product_brand?: string | null, product_productGroup?: { __typename?: 'productGroup', productGroup_type?: ProductGroupType | null, productGroup_displayName?: string | null, productGroup_forbiddenPostCodes?: Array<string | null> | null } | null, product_retailer?: { __typename?: 'retailer', retailer_colour?: string | null, retailer_logoUrl?: string | null, retailer_id?: string | null, retailer_displayName?: string | null, retailer_logoUrlSmall?: string | null, retailer_logoUrlLarge?: string | null, retailer_requireOverAgeCheck?: boolean | null, retailer_metadataTitleRetailer?: string | null, retailer_metadataDescriptionRetailer?: string | null, retailer_metadataTitleProductGroup?: string | null, retailer_metadataDescriptionProductGroup?: string | null, retailer_websiteURL?: string | null, retailer_deliveryMethod?: RetailerDeliveryMethod | null, retailer_shippingEstimationMessage?: string | null } | null } | null, variant?: { __typename?: 'advertVariant', available?: boolean | null, buyable?: boolean | null, countOnHand?: number | null, infiniteQuantity?: boolean | null, editablePrice?: number | null, editableSalePrice?: number | null, id?: string | null, imageUrls?: Array<string | null> | null, label?: string | null, published?: boolean | null, recommendedRetailPrice?: number | null, sku?: string | null, wholesalePrice?: string | null } | null } | null> | null } | { __typename: 'error', error_code?: string | null, error_message?: string | null } | null };

export type UpdateCartMetadataMutationVariables = Exact<{
  cartMetadata?: InputMaybe<CartMetadata>;
}>;


export type UpdateCartMetadataMutation = { __typename?: 'Mutation', updateCartMetadata?: { __typename: 'error', error_code?: string | null, error_message?: string | null } | { __typename?: 'successBool', isSuccess: boolean } | null };

export type UpdateCartMetadataCouponMutationVariables = Exact<{
  cartMetadata?: InputMaybe<CartMetadataCoupon>;
}>;


export type UpdateCartMetadataCouponMutation = { __typename?: 'Mutation', updateCartMetadataCoupon?: { __typename: 'cart', id?: string | null, billingCompanyName?: string | null, billingEmailAddress?: string | null, billingFirstName?: string | null, billingPhone?: string | null, billingSurname?: string | null, buyableQuantity?: number | null, messageToGiftRecipient?: string | null, messageToSeller?: string | null, shippingCostCents?: number | null, taxTotalCents?: number | null, createdAt?: string | null, couponCode?: string | null, discountCents?: number | null, subtotalCents?: number | null, totalCents?: number | null, cartSellers?: Array<{ __typename?: 'cartSeller', id?: string | null, baseDomesticShippingCost?: number | null, businessName?: string | null, domesticShippingFreeThreshold?: number | null, cartItemDeliveryMethodGroup?: Array<{ __typename?: 'cartItemDeliveryMethodGroup', deliveryMethod?: DeliveryMethod | null, discountCents?: number | null, shippingCostCents?: number | null, subtotalCents?: number | null, taxTotalCents?: number | null, totalCents?: number | null, shippingDescription?: string | null } | null> | null } | null> | null, address?: { __typename?: 'cartAddress', address?: string | null, city?: string | null, fullAddress?: string | null, postcode?: string | null, state?: string | null, subaddress?: string | null, country?: { __typename?: 'cartCountry', code?: string | null, name?: string | null } | null } | null, billingAddress?: { __typename?: 'cartAddress', address?: string | null, city?: string | null, fullAddress?: string | null, postcode?: string | null, state?: string | null, subaddress?: string | null, country?: { __typename?: 'cartCountry', code?: string | null, name?: string | null } | null } | null, items?: Array<{ __typename: 'cartItem', id?: string | null, deliveryMethod?: DeliveryMethod | null, discountCents?: number | null, hasFreeShippingDiscount?: boolean | null, internationalShippingAvailable?: boolean | null, internationalShippingRequired?: boolean | null, quantity?: number | null, shippingCostCents?: number | null, subtotalCents?: number | null, productId?: number | null, totalCents?: number | null, status?: CartItemStatus | null, seller?: { __typename?: 'sellerDetail', baseDomesticShippingCost?: number | null, businessName?: string | null, deliveryDetails?: string | null, domesticShippingFreeThreshold?: number | null, emailAddress?: string | null, id?: string | null, mailToUrl?: string | null, obscuredPhone?: string | null, phone?: string | null, returnPolicy?: string | null, sellerIsContactable?: boolean | null, servicePolicy?: string | null, showPhoneNumber?: boolean | null, underAdDescription?: string | null, underAdImpressum?: string | null } | null, advert?: { __typename?: 'advert', brand?: string | null, brandName?: string | null, category?: string | null, description?: string | null, displayImage?: string | null, editablePrice?: string | null, editableSalePrice?: string | null, fullTitle?: string | null, id?: string | null, sellerId?: string | null, title?: string | null, aoStockCodes?: Array<{ __typename: 'AoStock', key?: StateEnum | null, value?: number | null } | null> | null } | null, product?: { __typename: 'product', product_id?: string | null, product_price?: number | null, product_salePrice?: number | null, product_uomDescription?: string | null, product_description?: string | null, product_shippingDescription?: string | null, product_savingsPercentage?: number | null, product_buyNow?: boolean | null, product_name?: string | null, product_imageUrl?: string | null, product_hideDate?: boolean | null, product_endDate?: string | null, product_onPage?: number | null, product_inWishList?: boolean | null, product_imageMap?: string | null, product_isDuplicate?: boolean | null, product_isHidden?: boolean | null, product_startDate?: string | null, product_savingsAbsolute?: number | null, product_linkUrl?: string | null, product_title?: string | null, product_categorylevel1?: string | null, product_categorylevel2?: string | null, product_categorylevel3?: string | null, product_categorylevel?: number | null, product_retailerId?: string | null, product_additionalImageUrl?: Array<string | null> | null, product_productGroupId?: string | null, product_categoryId?: string | null, product_brand?: string | null, product_productGroup?: { __typename?: 'productGroup', productGroup_type?: ProductGroupType | null, productGroup_displayName?: string | null, productGroup_forbiddenPostCodes?: Array<string | null> | null } | null, product_retailer?: { __typename?: 'retailer', retailer_colour?: string | null, retailer_logoUrl?: string | null, retailer_id?: string | null, retailer_displayName?: string | null, retailer_logoUrlSmall?: string | null, retailer_logoUrlLarge?: string | null, retailer_requireOverAgeCheck?: boolean | null, retailer_metadataTitleRetailer?: string | null, retailer_metadataDescriptionRetailer?: string | null, retailer_metadataTitleProductGroup?: string | null, retailer_metadataDescriptionProductGroup?: string | null, retailer_websiteURL?: string | null, retailer_deliveryMethod?: RetailerDeliveryMethod | null, retailer_shippingEstimationMessage?: string | null } | null } | null, variant?: { __typename?: 'advertVariant', available?: boolean | null, buyable?: boolean | null, countOnHand?: number | null, infiniteQuantity?: boolean | null, editablePrice?: number | null, editableSalePrice?: number | null, id?: string | null, imageUrls?: Array<string | null> | null, label?: string | null, published?: boolean | null, recommendedRetailPrice?: number | null, sku?: string | null, wholesalePrice?: string | null } | null } | null> | null } | { __typename: 'error', error_code?: string | null, error_message?: string | null } | null };

export type GetProductBrandsFromSearchQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  productFilters?: InputMaybe<InputProductFilters>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProductBrandsFromSearchQuery = { __typename?: 'Query', getProductsForSearch: { __typename?: 'error' } | { __typename: 'productList', total?: number | null, brands?: Array<{ __typename: 'brand', brand_name?: string | null, brand_productCount?: string | null, brand_brandId?: string | null, brand_displayName?: string | null, brand_logoUrl?: string | null, brand_logoUrlSmall?: string | null, brand_logoUrlLarge?: string | null, brand_logoColor?: string | null, brand_sponsorUrl?: string | null, brand_sponsorText?: string | null, brand_keyword?: string | null, brand_fashion?: boolean | null, brand_order?: number | null, brand_tier1?: boolean | null, brand_availableForPreference?: boolean | null } | null> | null } };

export type GetAllBrandDetailsQueryVariables = Exact<{
  availableForPreference?: InputMaybe<Scalars['Boolean']['input']>;
  filterbyBrands?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  sortOrder?: InputMaybe<SortOrder>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllBrandDetailsQuery = { __typename?: 'Query', getAllBrands: { __typename: 'brandList', total?: number | null, items?: Array<{ __typename?: 'brand', brand_logoColor?: string | null, brand_logoUrl?: string | null, brand_brandId?: string | null, brand_displayName?: string | null } | null> | null } | { __typename?: 'error' } };

export type GetAllBrandsQueryVariables = Exact<{
  availableForPreference?: InputMaybe<Scalars['Boolean']['input']>;
  filterbyBrands?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  sortOrder?: InputMaybe<SortOrder>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllBrandsQuery = { __typename?: 'Query', getAllBrands: { __typename: 'brandList', total?: number | null, items?: Array<{ __typename?: 'brand', brand_logoColor?: string | null, brand_logoUrl?: string | null, brand_brandId?: string | null, brand_displayName?: string | null } | null> | null } | { __typename?: 'error' } };

export type GetAllCategoriesQueryVariables = Exact<{
  availableForPreference?: InputMaybe<Scalars['Boolean']['input']>;
  filterbyCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type GetAllCategoriesQuery = { __typename?: 'Query', getAllCategories: { __typename: 'categoryList', total?: number | null, items?: Array<{ __typename?: 'category', category_categoryId?: string | null, category_friendlyName?: string | null, category_name?: string | null, category_thumbnailUrl?: string | null, category_tileUrl?: string | null, category_order?: number | null, category_level1?: string | null, category_level2?: string | null, category_level3?: string | null, category_categorylevel?: number | null, category_iconUrl?: string | null, category_mainCategoryBannerUrl?: string | null, category_mainCategoryBannerColor?: string | null, category_subCategoryBannerUrl?: string | null, category_subCategoryBannerColor?: string | null, category_seoKeywords?: string | null, category_richDescription?: string | null, category_metadataTitle?: string | null, category_metadataDescription?: string | null } | null> | null } | { __typename?: 'error' } };

export type GetAllRetailerDetailsQueryVariables = Exact<{
  availableForPreference?: InputMaybe<Scalars['Boolean']['input']>;
  filterbyRetailers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  sortOrder?: InputMaybe<SortOrder>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<InputGeoloc>;
  filterbyRetailerName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllRetailerDetailsQuery = { __typename?: 'Query', getAllRetailers: { __typename?: 'error', error_code?: string | null, error_message?: string | null } | { __typename: 'retailerList', total?: number | null, items?: Array<{ __typename?: 'retailer', retailer_colour?: string | null, retailer_logoUrl?: string | null, retailer_id?: string | null, retailer_displayName?: string | null, retailer_logoUrlSmall?: string | null, retailer_logoUrlLarge?: string | null, retailer_requireOverAgeCheck?: boolean | null, retailer_metadataTitleRetailer?: string | null, retailer_metadataDescriptionRetailer?: string | null, retailer_metadataTitleProductGroup?: string | null, retailer_metadataDescriptionProductGroup?: string | null, retailer_websiteURL?: string | null, retailer_deliveryMethod?: RetailerDeliveryMethod | null, retailer_description?: string | null, retailer_locations?: Array<{ __typename?: 'location', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, displayName?: string | null, locationId?: string | null, postCode?: string | null, state?: string | null, suburb?: string | null, storeHours?: { __typename?: 'storeHours', sunday?: { __typename?: 'storeHoursDay', closeHours: string, startHours: string } | null, monday?: { __typename?: 'storeHoursDay', closeHours: string, startHours: string } | null, tuesday?: { __typename?: 'storeHoursDay', closeHours: string, startHours: string } | null, wednesday?: { __typename?: 'storeHoursDay', closeHours: string, startHours: string } | null, thursday?: { __typename?: 'storeHoursDay', closeHours: string, startHours: string } | null, friday?: { __typename?: 'storeHoursDay', closeHours: string, startHours: string } | null, saturday?: { __typename?: 'storeHoursDay', closeHours: string, startHours: string } | null } | null, geopoint?: { __typename?: 'geoloc', lat?: number | null, lon?: number | null } | null } | null> | null } | null> | null } };

export type GetAllRetailersQueryVariables = Exact<{
  availableForPreference?: InputMaybe<Scalars['Boolean']['input']>;
  tier1?: InputMaybe<Scalars['Boolean']['input']>;
  filterbyRetailers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  sortOrder?: InputMaybe<SortOrder>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllRetailersQuery = { __typename?: 'Query', getAllRetailers: { __typename?: 'error', error_code?: string | null, error_message?: string | null } | { __typename: 'retailerList', total?: number | null, items?: Array<{ __typename?: 'retailer', retailer_colour?: string | null, retailer_logoUrl?: string | null, retailer_id?: string | null, retailer_displayName?: string | null, retailer_logoUrlSmall?: string | null, retailer_logoUrlLarge?: string | null, retailer_requireOverAgeCheck?: boolean | null, retailer_metadataTitleRetailer?: string | null, retailer_metadataDescriptionRetailer?: string | null, retailer_metadataTitleProductGroup?: string | null, retailer_metadataDescriptionProductGroup?: string | null, retailer_websiteURL?: string | null, retailer_deliveryMethod?: RetailerDeliveryMethod | null } | null> | null } };

export type GetAutoCompleteQueryVariables = Exact<{
  searchterm?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAutoCompleteQuery = { __typename?: 'Query', getAutocomplete?: { __typename: 'autocomplete', total?: number | null, items?: Array<string | null> | null } | null };

export type GetBasicAdsQueryVariables = Exact<{
  position: AdPosition;
}>;


export type GetBasicAdsQuery = { __typename?: 'Query', getBasicAds?: { __typename: 'AdList', items: Array<{ __typename?: 'Ad', description?: string | null, endDate?: string | null, externalId?: string | null, id?: number | null, imageLarge?: string | null, imageLargePublic?: string | null, imageLink?: string | null, imageSmall?: string | null, imageSmallPublic?: string | null, orderDate?: string | null, position?: AdPosition | null, retailerCode?: string | null, startDate?: string | null, title?: string | null } | null> } | { __typename: 'error', error_code?: string | null, error_message?: string | null } | null };

export type GetBrandsQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  productFilters?: InputMaybe<InputProductFilters>;
  filterbyBrandName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBrandsQuery = { __typename?: 'Query', getBrands: { __typename: 'brandList', total?: number | null, items?: Array<{ __typename?: 'brand', brand_name?: string | null, brand_productCount?: string | null, brand_brandId?: string | null } | null> | null } | { __typename?: 'error' } };

export type GetCartQueryVariables = Exact<{
  cartId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCartQuery = { __typename?: 'Query', getCart?: { __typename: 'cart', id?: string | null, billingCompanyName?: string | null, billingEmailAddress?: string | null, billingFirstName?: string | null, billingPhone?: string | null, billingSurname?: string | null, buyableQuantity?: number | null, messageToGiftRecipient?: string | null, messageToSeller?: string | null, shippingCostCents?: number | null, taxTotalCents?: number | null, createdAt?: string | null, couponCode?: string | null, discountCents?: number | null, subtotalCents?: number | null, totalCents?: number | null, cartSellers?: Array<{ __typename?: 'cartSeller', id?: string | null, baseDomesticShippingCost?: number | null, businessName?: string | null, domesticShippingFreeThreshold?: number | null, cartItemDeliveryMethodGroup?: Array<{ __typename?: 'cartItemDeliveryMethodGroup', deliveryMethod?: DeliveryMethod | null, discountCents?: number | null, shippingCostCents?: number | null, subtotalCents?: number | null, taxTotalCents?: number | null, totalCents?: number | null, shippingDescription?: string | null } | null> | null } | null> | null, address?: { __typename?: 'cartAddress', address?: string | null, city?: string | null, fullAddress?: string | null, postcode?: string | null, state?: string | null, subaddress?: string | null, country?: { __typename?: 'cartCountry', code?: string | null, name?: string | null } | null } | null, billingAddress?: { __typename?: 'cartAddress', address?: string | null, city?: string | null, fullAddress?: string | null, postcode?: string | null, state?: string | null, subaddress?: string | null, country?: { __typename?: 'cartCountry', code?: string | null, name?: string | null } | null } | null, items?: Array<{ __typename: 'cartItem', id?: string | null, deliveryMethod?: DeliveryMethod | null, discountCents?: number | null, hasFreeShippingDiscount?: boolean | null, internationalShippingAvailable?: boolean | null, internationalShippingRequired?: boolean | null, quantity?: number | null, shippingCostCents?: number | null, subtotalCents?: number | null, productId?: number | null, totalCents?: number | null, status?: CartItemStatus | null, seller?: { __typename?: 'sellerDetail', baseDomesticShippingCost?: number | null, businessName?: string | null, deliveryDetails?: string | null, domesticShippingFreeThreshold?: number | null, emailAddress?: string | null, id?: string | null, mailToUrl?: string | null, obscuredPhone?: string | null, phone?: string | null, returnPolicy?: string | null, sellerIsContactable?: boolean | null, servicePolicy?: string | null, showPhoneNumber?: boolean | null, underAdDescription?: string | null, underAdImpressum?: string | null } | null, advert?: { __typename?: 'advert', brand?: string | null, brandName?: string | null, category?: string | null, description?: string | null, displayImage?: string | null, editablePrice?: string | null, editableSalePrice?: string | null, fullTitle?: string | null, id?: string | null, sellerId?: string | null, title?: string | null, aoStockCodes?: Array<{ __typename: 'AoStock', key?: StateEnum | null, value?: number | null } | null> | null } | null, product?: { __typename: 'product', product_id?: string | null, product_price?: number | null, product_salePrice?: number | null, product_uomDescription?: string | null, product_description?: string | null, product_shippingDescription?: string | null, product_savingsPercentage?: number | null, product_buyNow?: boolean | null, product_name?: string | null, product_imageUrl?: string | null, product_hideDate?: boolean | null, product_endDate?: string | null, product_onPage?: number | null, product_inWishList?: boolean | null, product_imageMap?: string | null, product_isDuplicate?: boolean | null, product_isHidden?: boolean | null, product_startDate?: string | null, product_savingsAbsolute?: number | null, product_linkUrl?: string | null, product_title?: string | null, product_categorylevel1?: string | null, product_categorylevel2?: string | null, product_categorylevel3?: string | null, product_categorylevel?: number | null, product_retailerId?: string | null, product_additionalImageUrl?: Array<string | null> | null, product_productGroupId?: string | null, product_categoryId?: string | null, product_brand?: string | null, product_productGroup?: { __typename?: 'productGroup', productGroup_type?: ProductGroupType | null, productGroup_displayName?: string | null, productGroup_forbiddenPostCodes?: Array<string | null> | null } | null, product_retailer?: { __typename?: 'retailer', retailer_colour?: string | null, retailer_logoUrl?: string | null, retailer_id?: string | null, retailer_displayName?: string | null, retailer_logoUrlSmall?: string | null, retailer_logoUrlLarge?: string | null, retailer_requireOverAgeCheck?: boolean | null, retailer_metadataTitleRetailer?: string | null, retailer_metadataDescriptionRetailer?: string | null, retailer_metadataTitleProductGroup?: string | null, retailer_metadataDescriptionProductGroup?: string | null, retailer_websiteURL?: string | null, retailer_deliveryMethod?: RetailerDeliveryMethod | null, retailer_shippingEstimationMessage?: string | null } | null } | null, variant?: { __typename?: 'advertVariant', available?: boolean | null, buyable?: boolean | null, countOnHand?: number | null, infiniteQuantity?: boolean | null, editablePrice?: number | null, editableSalePrice?: number | null, id?: string | null, imageUrls?: Array<string | null> | null, label?: string | null, published?: boolean | null, recommendedRetailPrice?: number | null, sku?: string | null, wholesalePrice?: string | null } | null } | null> | null } | { __typename: 'error', error_code?: string | null, error_message?: string | null } | null };

export type GetCartByIdQueryVariables = Exact<{
  cartId: Scalars['String']['input'];
}>;


export type GetCartByIdQuery = { __typename?: 'Query', getCartById?: { __typename: 'cart', id?: string | null, billingCompanyName?: string | null, billingEmailAddress?: string | null, billingFirstName?: string | null, billingPhone?: string | null, billingSurname?: string | null, buyableQuantity?: number | null, messageToGiftRecipient?: string | null, messageToSeller?: string | null, shippingCostCents?: number | null, taxTotalCents?: number | null, createdAt?: string | null, couponCode?: string | null, discountCents?: number | null, subtotalCents?: number | null, totalCents?: number | null, cartSellers?: Array<{ __typename?: 'cartSeller', id?: string | null, baseDomesticShippingCost?: number | null, businessName?: string | null, domesticShippingFreeThreshold?: number | null, cartItemDeliveryMethodGroup?: Array<{ __typename?: 'cartItemDeliveryMethodGroup', deliveryMethod?: DeliveryMethod | null, discountCents?: number | null, shippingCostCents?: number | null, subtotalCents?: number | null, taxTotalCents?: number | null, totalCents?: number | null, shippingDescription?: string | null } | null> | null } | null> | null, address?: { __typename?: 'cartAddress', address?: string | null, city?: string | null, fullAddress?: string | null, postcode?: string | null, state?: string | null, subaddress?: string | null, country?: { __typename?: 'cartCountry', code?: string | null, name?: string | null } | null } | null, billingAddress?: { __typename?: 'cartAddress', address?: string | null, city?: string | null, fullAddress?: string | null, postcode?: string | null, state?: string | null, subaddress?: string | null, country?: { __typename?: 'cartCountry', code?: string | null, name?: string | null } | null } | null, items?: Array<{ __typename: 'cartItem', id?: string | null, deliveryMethod?: DeliveryMethod | null, discountCents?: number | null, hasFreeShippingDiscount?: boolean | null, internationalShippingAvailable?: boolean | null, internationalShippingRequired?: boolean | null, quantity?: number | null, shippingCostCents?: number | null, subtotalCents?: number | null, productId?: number | null, totalCents?: number | null, status?: CartItemStatus | null, seller?: { __typename?: 'sellerDetail', baseDomesticShippingCost?: number | null, businessName?: string | null, deliveryDetails?: string | null, domesticShippingFreeThreshold?: number | null, emailAddress?: string | null, id?: string | null, mailToUrl?: string | null, obscuredPhone?: string | null, phone?: string | null, returnPolicy?: string | null, sellerIsContactable?: boolean | null, servicePolicy?: string | null, showPhoneNumber?: boolean | null, underAdDescription?: string | null, underAdImpressum?: string | null } | null, advert?: { __typename?: 'advert', brand?: string | null, brandName?: string | null, category?: string | null, description?: string | null, displayImage?: string | null, editablePrice?: string | null, editableSalePrice?: string | null, fullTitle?: string | null, id?: string | null, sellerId?: string | null, title?: string | null, aoStockCodes?: Array<{ __typename: 'AoStock', key?: StateEnum | null, value?: number | null } | null> | null } | null, product?: { __typename: 'product', product_id?: string | null, product_price?: number | null, product_salePrice?: number | null, product_uomDescription?: string | null, product_description?: string | null, product_shippingDescription?: string | null, product_savingsPercentage?: number | null, product_buyNow?: boolean | null, product_name?: string | null, product_imageUrl?: string | null, product_hideDate?: boolean | null, product_endDate?: string | null, product_onPage?: number | null, product_inWishList?: boolean | null, product_imageMap?: string | null, product_isDuplicate?: boolean | null, product_isHidden?: boolean | null, product_startDate?: string | null, product_savingsAbsolute?: number | null, product_linkUrl?: string | null, product_title?: string | null, product_categorylevel1?: string | null, product_categorylevel2?: string | null, product_categorylevel3?: string | null, product_categorylevel?: number | null, product_retailerId?: string | null, product_additionalImageUrl?: Array<string | null> | null, product_productGroupId?: string | null, product_categoryId?: string | null, product_brand?: string | null, product_productGroup?: { __typename?: 'productGroup', productGroup_type?: ProductGroupType | null, productGroup_displayName?: string | null, productGroup_forbiddenPostCodes?: Array<string | null> | null } | null, product_retailer?: { __typename?: 'retailer', retailer_colour?: string | null, retailer_logoUrl?: string | null, retailer_id?: string | null, retailer_displayName?: string | null, retailer_logoUrlSmall?: string | null, retailer_logoUrlLarge?: string | null, retailer_requireOverAgeCheck?: boolean | null, retailer_metadataTitleRetailer?: string | null, retailer_metadataDescriptionRetailer?: string | null, retailer_metadataTitleProductGroup?: string | null, retailer_metadataDescriptionProductGroup?: string | null, retailer_websiteURL?: string | null, retailer_deliveryMethod?: RetailerDeliveryMethod | null, retailer_shippingEstimationMessage?: string | null } | null } | null, variant?: { __typename?: 'advertVariant', available?: boolean | null, buyable?: boolean | null, countOnHand?: number | null, infiniteQuantity?: boolean | null, editablePrice?: number | null, editableSalePrice?: number | null, id?: string | null, imageUrls?: Array<string | null> | null, label?: string | null, published?: boolean | null, recommendedRetailPrice?: number | null, sku?: string | null, wholesalePrice?: string | null } | null } | null> | null } | { __typename: 'error', error_code?: string | null, error_message?: string | null } | null };

export type GetCatalogueByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCatalogueByIdQuery = { __typename?: 'Query', getProductGroups: { __typename: 'error', error_code?: string | null, error_message?: string | null } | { __typename: 'productGroupList', items?: Array<{ __typename?: 'productGroup', productGroup_productGroupId?: string | null, productGroup_startDate?: string | null, productGroup_endDate?: string | null, productGroup_hideDate?: boolean | null, productGroup_linkUrl?: string | null, productGroup_numberOfPages?: number | null, productGroup_termsAndConditions?: string | null, productGroup_instructions?: string | null, productGroup_buyNow?: boolean | null, productGroup_isMarketplace?: boolean | null, productGroup_type?: ProductGroupType | null, productGroup_isBundle?: boolean | null, productGroup_productsTotal?: number | null, productGroup_displayName?: string | null, productGroup_productGroupImage?: string | null, productGroup_publicationDate?: string | null, productGroup_postcodes?: Array<string | null> | null, productGroup_forbiddenPostCodes?: Array<string | null> | null, productGroup_pageLinks?: Array<{ __typename: 'pageLink', pageNumber?: string | null, imagePath?: string | null } | null> | null, productGroup_metadata?: Array<{ __typename?: 'productGroupMetadata', productGroupMetadata_imageMap?: string | null, productGroupMetadata_metadataId?: string | null, productGroupMetadata_pageNo?: string | null, productGroupMetadata_type?: string | null, productGroupMetadata_productGroupId?: string | null, productGroupMetadata_displayName?: string | null, productGroupMetadata_name?: string | null, productGroupMetadata_offerId?: string | null, productGroupMetadata_imagePath?: string | null, productGroupMetadata_metaText?: string | null, productGroupMetadata_videoUrl?: string | null, productGroupMetadata_metaUrl?: string | null, productGroupMetadata_linkToPage?: string | null } | null> | null, productGroup_retailer?: { __typename?: 'retailer', retailer_colour?: string | null, retailer_logoUrl?: string | null, retailer_id?: string | null, retailer_displayName?: string | null, retailer_logoUrlSmall?: string | null, retailer_logoUrlLarge?: string | null, retailer_requireOverAgeCheck?: boolean | null, retailer_metadataTitleRetailer?: string | null, retailer_metadataDescriptionRetailer?: string | null, retailer_metadataTitleProductGroup?: string | null, retailer_metadataDescriptionProductGroup?: string | null, retailer_websiteURL?: string | null, retailer_deliveryMethod?: RetailerDeliveryMethod | null } | null } | null> | null } };

export type GetCataloguesQueryVariables = Exact<{
  random?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  productFilters?: InputMaybe<InputProductFilters>;
  trendingNow?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCataloguesQuery = { __typename?: 'Query', getProductGroups: { __typename: 'error' } | { __typename: 'productGroupList', total?: number | null, items?: Array<{ __typename?: 'productGroup', productGroup_productGroupImage?: string | null, productGroup_thumbnailUrl?: string | null, productGroup_productGroupId?: string | null, productGroup_endDate?: string | null, productGroup_hideDate?: boolean | null, productGroup_displayName?: string | null, productGroup_type?: ProductGroupType | null, productGroup_productsTotal?: number | null, productGroup_forbiddenPostCodes?: Array<string | null> | null, productGroup_metadata?: Array<{ __typename?: 'productGroupMetadata', productGroupMetadata_imageMap?: string | null, productGroupMetadata_metadataId?: string | null, productGroupMetadata_pageNo?: string | null, productGroupMetadata_type?: string | null, productGroupMetadata_productGroupId?: string | null, productGroupMetadata_displayName?: string | null, productGroupMetadata_name?: string | null, productGroupMetadata_offerId?: string | null, productGroupMetadata_imagePath?: string | null, productGroupMetadata_metaText?: string | null, productGroupMetadata_videoUrl?: string | null, productGroupMetadata_metaUrl?: string | null, productGroupMetadata_linkToPage?: string | null } | null> | null, productGroup_pageLinks?: Array<{ __typename: 'pageLink', pageNumber?: string | null, imagePath?: string | null } | null> | null, productGroup_retailer?: { __typename?: 'retailer', retailer_colour?: string | null, retailer_logoUrl?: string | null, retailer_id?: string | null, retailer_displayName?: string | null, retailer_logoUrlSmall?: string | null, retailer_logoUrlLarge?: string | null, retailer_requireOverAgeCheck?: boolean | null, retailer_metadataTitleRetailer?: string | null, retailer_metadataDescriptionRetailer?: string | null, retailer_metadataTitleProductGroup?: string | null, retailer_metadataDescriptionProductGroup?: string | null, retailer_websiteURL?: string | null, retailer_deliveryMethod?: RetailerDeliveryMethod | null } | null } | null> | null } };

export type GetCategoriesQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
  context?: InputMaybe<CategoryContext>;
  productFilters?: InputMaybe<InputProductFilters>;
  parentCategory?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCategoriesQuery = { __typename?: 'Query', getCategories: { __typename: 'categoryList', total?: number | null, items?: Array<{ __typename?: 'category', category_categoryId?: string | null, category_categorylevel?: number | null, category_friendlyName?: string | null, category_level1?: string | null, category_level2?: string | null, category_level3?: string | null, category_name?: string | null, category_order?: number | null, category_thumbnailUrl?: string | null, category_tileUrl?: string | null, category_iconUrl?: string | null, category_mainCategoryBannerUrl?: string | null, category_mainCategoryBannerColor?: string | null, category_subCategoryBannerUrl?: string | null, category_subCategoryBannerColor?: string | null, category_seoKeywords?: string | null, category_richDescription?: string | null, category_metadataTitle?: string | null, category_metadataDescription?: string | null, category_hideFromMenu?: boolean | null } | null> | null } | { __typename?: 'error' } };

export type GetCategoryByLevelNameQueryVariables = Exact<{
  slug_1?: InputMaybe<Scalars['String']['input']>;
  slug_2?: InputMaybe<Scalars['String']['input']>;
  slug_3?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCategoryByLevelNameQuery = { __typename?: 'Query', getCategoryByLevelName: { __typename: 'category', category_categorylevel?: number | null, category_productCount?: number | null, category_level1?: string | null, category_level2?: string | null, category_level3?: string | null, category_categoryId?: string | null, category_name?: string | null, category_friendlyName?: string | null, category_mainCategoryBannerUrl?: string | null, category_mainCategoryBannerColor?: string | null, category_subCategoryBannerUrl?: string | null, category_subCategoryBannerColor?: string | null, category_seoKeywords?: string | null, category_richDescription?: string | null, category_metadataDescription?: string | null, category_metadataTitle?: string | null, category_thumbnailUrl?: string | null } | { __typename: 'error', error_code?: string | null, error_message?: string | null } };

export type GetCategoryDetailsByIdQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
  productFilters?: InputMaybe<InputProductFilters>;
  parentCategory?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCategoryDetailsByIdQuery = { __typename?: 'Query', getCategoryDetailsById: { __typename: 'categoryList', items?: Array<{ __typename?: 'category', category_categoryId?: string | null, category_friendlyName?: string | null, category_name?: string | null, category_thumbnailUrl?: string | null, category_tileUrl?: string | null, category_order?: number | null, category_level1?: string | null, category_level2?: string | null, category_level3?: string | null, category_categorylevel?: number | null, category_iconUrl?: string | null, category_mainCategoryBannerUrl?: string | null, category_mainCategoryBannerColor?: string | null, category_subCategoryBannerUrl?: string | null, category_subCategoryBannerColor?: string | null, category_seoKeywords?: string | null, category_richDescription?: string | null, category_metadataTitle?: string | null, category_metadataDescription?: string | null } | null> | null } | { __typename: 'error', error_code?: string | null, error_message?: string | null } };

export type GetFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeaturesQuery = { __typename?: 'Query', getFeatures?: { __typename: 'error', error_code?: string | null, error_message?: string | null } | { __typename: 'features', items?: Array<string | null> | null, config?: string | null } | null };

export type GetInventoryForFirstVariantQueryVariables = Exact<{
  advertId: Scalars['ID']['input'];
}>;


export type GetInventoryForFirstVariantQuery = { __typename?: 'Query', getInventoryForFirstVariant?: { __typename: 'error', error_code?: string | null, error_message?: string | null } | { __typename: 'inventoryStatus', id?: string | null, available?: boolean | null } | null };

export type GetInventoryForVariantQueryVariables = Exact<{
  advertId: Scalars['ID']['input'];
  variantId: Scalars['ID']['input'];
}>;


export type GetInventoryForVariantQuery = { __typename?: 'Query', getInventoryForVariant?: { __typename: 'error', error_code?: string | null, error_message?: string | null } | { __typename: 'inventoryStatus', id?: string | null, available?: boolean | null } | null };

export type GetOrderQueryVariables = Exact<{
  permalink: Scalars['String']['input'];
}>;


export type GetOrderQuery = { __typename?: 'Query', getOrder?: { __typename: 'error', error_code?: string | null, error_message?: string | null } | { __typename: 'order', id?: string | null, total?: number | null, aggregateInvoiceStatusFinal?: boolean | null, billingCompanyName?: string | null, billingEmailAddress?: string | null, billingFirstName?: string | null, billingPhone?: string | null, billingSurname?: string | null, companyName?: string | null, createdAt?: string | null, updatedAt?: string | null, discountCents?: number | null, emailAddress?: string | null, expectedDeliveryDate?: string | null, expectedDeliverySlot?: string | null, firstName?: string | null, isGift?: boolean | null, messageToGiftRecipient?: string | null, messageToSeller?: string | null, paymentGatewayDetails?: string | null, paymentInstrumentType?: string | null, permalink?: string | null, phone?: string | null, shippingCostCents?: number | null, status?: OrderStatus | null, subtotal?: number | null, subtotalCents?: number | null, surname?: string | null, taxTotal?: number | null, taxTotalCents?: number | null, token?: string | null, totalCents?: number | null, address?: { __typename?: 'cartAddress', address?: string | null, city?: string | null, fullAddress?: string | null, postcode?: string | null, state?: string | null, subaddress?: string | null, country?: { __typename?: 'cartCountry', code?: string | null, name?: string | null } | null } | null, billingAddress?: { __typename?: 'cartAddress', address?: string | null, city?: string | null, fullAddress?: string | null, postcode?: string | null, state?: string | null, subaddress?: string | null, country?: { __typename?: 'cartCountry', code?: string | null, name?: string | null } | null } | null, invoices?: Array<{ __typename?: 'invoice', id?: string | null, paidAt?: string | null, paymentInstrumentType?: string | null, pdfLink?: string | null, shippingCostCents?: number | null, shippingDescription?: string | null, shippingFromLocationMessage?: string | null, statusFlags?: Array<InvoiceStatus | null> | null, subtotalCents?: number | null, taxShippingCents?: number | null, taxTotalCents?: number | null, totalCents?: number | null, lineItems?: Array<{ __typename?: 'lineItem', advertCode?: string | null, advertId?: string | null, advertTitle?: string | null, discountCents?: number | null, id?: string | null, image?: string | null, postageCents?: number | null, productId?: number | null, quantity?: number | null, quantityAwaitingDispatch?: number | null, statusFull?: LineItemStatus | null, subtotalCents?: number | null, taxTotalCents?: number | null, totalCents?: number | null, variantBarcode?: string | null, variantId?: string | null, variantName?: string | null, variantSku?: string | null, shipments?: Array<{ __typename?: 'shipment', carrier?: string | null, createdAt?: string | null, dispatchedAt?: string | null, id?: string | null, trackingLink?: string | null, trackingNumber?: string | null, updatedAt?: string | null } | null> | null } | null> | null, seller?: { __typename?: 'sellerDetail', baseDomesticShippingCost?: number | null, businessName?: string | null, deliveryDetails?: string | null, domesticShippingFreeThreshold?: number | null, emailAddress?: string | null, id?: string | null, mailToUrl?: string | null, obscuredPhone?: string | null, phone?: string | null, returnPolicy?: string | null, sellerIsContactable?: boolean | null, servicePolicy?: string | null, showPhoneNumber?: boolean | null, underAdDescription?: string | null, underAdImpressum?: string | null } | null, retailer?: { __typename?: 'retailerDetail', displayName?: string | null, isPublished?: boolean | null, color?: string | null, logoUrl?: string | null, logoUrlLarge?: string | null, logoUrlSmall?: string | null, name?: string | null, retailerCategories?: Array<string | null> | null, retailerId?: string | null, shippingEstimationMessage?: string | null, websiteURL?: string | null } | null } | null> | null } | { __typename: 'userActionError' } | null };

export type GetOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrdersQuery = { __typename?: 'Query', getOrders?: { __typename: 'error', error_code?: string | null, error_message?: string | null } | { __typename: 'orderList', items?: Array<{ __typename?: 'order', id?: string | null, total?: number | null, aggregateInvoiceStatusFinal?: boolean | null, billingCompanyName?: string | null, billingEmailAddress?: string | null, billingFirstName?: string | null, billingPhone?: string | null, billingSurname?: string | null, companyName?: string | null, createdAt?: string | null, updatedAt?: string | null, discountCents?: number | null, emailAddress?: string | null, expectedDeliveryDate?: string | null, expectedDeliverySlot?: string | null, firstName?: string | null, isGift?: boolean | null, messageToGiftRecipient?: string | null, messageToSeller?: string | null, paymentGatewayDetails?: string | null, paymentInstrumentType?: string | null, permalink?: string | null, phone?: string | null, shippingCostCents?: number | null, status?: OrderStatus | null, subtotal?: number | null, subtotalCents?: number | null, surname?: string | null, taxTotal?: number | null, taxTotalCents?: number | null, token?: string | null, totalCents?: number | null, address?: { __typename?: 'cartAddress', address?: string | null, city?: string | null, fullAddress?: string | null, postcode?: string | null, state?: string | null, subaddress?: string | null, country?: { __typename?: 'cartCountry', code?: string | null, name?: string | null } | null } | null, billingAddress?: { __typename?: 'cartAddress', address?: string | null, city?: string | null, fullAddress?: string | null, postcode?: string | null, state?: string | null, subaddress?: string | null, country?: { __typename?: 'cartCountry', code?: string | null, name?: string | null } | null } | null, invoices?: Array<{ __typename?: 'invoice', lineItems?: Array<{ __typename?: 'lineItem', advertTitle?: string | null, quantity?: number | null, image?: string | null } | null> | null } | null> | null } | null> | null } | null };

export type GetPaymentTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentTokenQuery = { __typename?: 'Query', getPaymentToken?: { __typename: 'error', error_code?: string | null, error_message?: string | null } | { __typename: 'paymentToken', paymentToken: string } | null };

export type GetPremiumAdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPremiumAdsQuery = { __typename?: 'Query', getPremiumAds?: { __typename: 'AdList', items: Array<{ __typename?: 'Ad', description?: string | null, endDate?: string | null, externalId?: string | null, id?: number | null, imageLarge?: string | null, imageLargePublic?: string | null, imageLink?: string | null, imageSmall?: string | null, imageSmallPublic?: string | null, orderDate?: string | null, position?: AdPosition | null, retailerCode?: string | null, startDate?: string | null, title?: string | null } | null> } | { __typename: 'error', error_code?: string | null, error_message?: string | null } | null };

export type GetProductVariantImagesQueryVariables = Exact<{
  advertId: Scalars['String']['input'];
}>;


export type GetProductVariantImagesQuery = { __typename?: 'Query', getProductVariantImages?: { __typename: 'error' } | { __typename: 'productVariantImageList', items?: Array<{ __typename?: 'variantImage', url?: string | null, sku?: string | null, filename?: string | null, position?: number | null } | null> | null } | null };

export type GetProductsQueryVariables = Exact<{
  random?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  productFilters?: InputMaybe<InputProductFilters>;
  trendingNow?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProductsQuery = { __typename?: 'Query', getProducts: { __typename: 'error' } | { __typename: 'productList', total?: number | null, items?: Array<{ __typename: 'product', product_id?: string | null, product_price?: number | null, product_salePrice?: number | null, product_uomDescription?: string | null, product_description?: string | null, product_shippingDescription?: string | null, product_savingsPercentage?: number | null, product_buyNow?: boolean | null, product_name?: string | null, product_imageUrl?: string | null, product_hideDate?: boolean | null, product_endDate?: string | null, product_onPage?: number | null, product_inWishList?: boolean | null, product_imageMap?: string | null, product_isDuplicate?: boolean | null, product_isHidden?: boolean | null, product_startDate?: string | null, product_savingsAbsolute?: number | null, product_linkUrl?: string | null, product_title?: string | null, product_categorylevel1?: string | null, product_categorylevel2?: string | null, product_categorylevel3?: string | null, product_categorylevel?: number | null, product_retailerId?: string | null, product_additionalImageUrl?: Array<string | null> | null, product_productGroupId?: string | null, product_categoryId?: string | null, product_isPurchasableOnline?: boolean | null, product_multiVariant?: boolean | null, product_multiPrice?: boolean | null, product_advertLookUp?: string | null, product_brand?: string | null, product_productGroup?: { __typename?: 'productGroup', productGroup_type?: ProductGroupType | null, productGroup_displayName?: string | null, productGroup_forbiddenPostCodes?: Array<string | null> | null } | null, product_retailer?: { __typename?: 'retailer', retailer_colour?: string | null, retailer_logoUrl?: string | null, retailer_id?: string | null, retailer_displayName?: string | null, retailer_logoUrlSmall?: string | null, retailer_logoUrlLarge?: string | null, retailer_requireOverAgeCheck?: boolean | null, retailer_metadataTitleRetailer?: string | null, retailer_metadataDescriptionRetailer?: string | null, retailer_metadataTitleProductGroup?: string | null, retailer_metadataDescriptionProductGroup?: string | null, retailer_websiteURL?: string | null, retailer_deliveryMethod?: RetailerDeliveryMethod | null, retailer_shippingEstimationMessage?: string | null } | null } | null> | null, brands?: Array<{ __typename: 'brand', brand_name?: string | null, brand_productCount?: string | null, brand_brandId?: string | null, brand_displayName?: string | null, brand_logoUrl?: string | null, brand_logoUrlSmall?: string | null, brand_logoUrlLarge?: string | null, brand_logoColor?: string | null, brand_sponsorUrl?: string | null, brand_sponsorText?: string | null, brand_keyword?: string | null, brand_fashion?: boolean | null, brand_order?: number | null, brand_tier1?: boolean | null, brand_availableForPreference?: boolean | null } | null> | null } };

export type GetProductsBrandsFromCatalogueQueryVariables = Exact<{
  random?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  productFilters?: InputMaybe<InputProductFilters>;
}>;


export type GetProductsBrandsFromCatalogueQuery = { __typename?: 'Query', getProducts: { __typename?: 'error' } | { __typename: 'productList', total?: number | null, brands?: Array<{ __typename: 'brand', brand_name?: string | null, brand_productCount?: string | null, brand_brandId?: string | null, brand_displayName?: string | null, brand_logoUrl?: string | null, brand_logoUrlSmall?: string | null, brand_logoUrlLarge?: string | null, brand_logoColor?: string | null, brand_sponsorUrl?: string | null, brand_sponsorText?: string | null, brand_keyword?: string | null, brand_fashion?: boolean | null, brand_order?: number | null, brand_tier1?: boolean | null, brand_availableForPreference?: boolean | null } | null> | null } };

export type GetProductsFromPersonalizationQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  productFilters?: InputMaybe<InputProductFilters>;
}>;


export type GetProductsFromPersonalizationQuery = { __typename?: 'Query', getProductsFromPersonalization: { __typename: 'error' } | { __typename: 'productList', total?: number | null, items?: Array<{ __typename: 'product', product_id?: string | null, product_price?: number | null, product_salePrice?: number | null, product_uomDescription?: string | null, product_description?: string | null, product_shippingDescription?: string | null, product_savingsPercentage?: number | null, product_buyNow?: boolean | null, product_name?: string | null, product_imageUrl?: string | null, product_hideDate?: boolean | null, product_endDate?: string | null, product_onPage?: number | null, product_inWishList?: boolean | null, product_imageMap?: string | null, product_isDuplicate?: boolean | null, product_isHidden?: boolean | null, product_startDate?: string | null, product_savingsAbsolute?: number | null, product_linkUrl?: string | null, product_title?: string | null, product_categorylevel1?: string | null, product_categorylevel2?: string | null, product_categorylevel3?: string | null, product_categorylevel?: number | null, product_retailerId?: string | null, product_additionalImageUrl?: Array<string | null> | null, product_productGroupId?: string | null, product_categoryId?: string | null, product_isPurchasableOnline?: boolean | null, product_multiVariant?: boolean | null, product_multiPrice?: boolean | null, product_advertLookUp?: string | null, product_brand?: string | null, product_productGroup?: { __typename?: 'productGroup', productGroup_type?: ProductGroupType | null, productGroup_displayName?: string | null, productGroup_forbiddenPostCodes?: Array<string | null> | null } | null, product_retailer?: { __typename?: 'retailer', retailer_colour?: string | null, retailer_logoUrl?: string | null, retailer_id?: string | null, retailer_displayName?: string | null, retailer_logoUrlSmall?: string | null, retailer_logoUrlLarge?: string | null, retailer_requireOverAgeCheck?: boolean | null, retailer_metadataTitleRetailer?: string | null, retailer_metadataDescriptionRetailer?: string | null, retailer_metadataTitleProductGroup?: string | null, retailer_metadataDescriptionProductGroup?: string | null, retailer_websiteURL?: string | null, retailer_deliveryMethod?: RetailerDeliveryMethod | null, retailer_shippingEstimationMessage?: string | null } | null } | null> | null } };

export type GetProductsForSearchV2QueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  productFilters?: InputMaybe<InputProductFilters>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type GetProductsForSearchV2Query = { __typename?: 'Query', getProductsForSearchV2: { __typename: 'error' } | { __typename: 'v2SearchProductList', total?: number | null, autocorrectedSearchTerms?: string | null, items?: Array<{ __typename: 'product', product_id?: string | null, product_price?: number | null, product_salePrice?: number | null, product_uomDescription?: string | null, product_description?: string | null, product_shippingDescription?: string | null, product_savingsPercentage?: number | null, product_buyNow?: boolean | null, product_name?: string | null, product_imageUrl?: string | null, product_hideDate?: boolean | null, product_endDate?: string | null, product_onPage?: number | null, product_inWishList?: boolean | null, product_imageMap?: string | null, product_isDuplicate?: boolean | null, product_isHidden?: boolean | null, product_startDate?: string | null, product_savingsAbsolute?: number | null, product_linkUrl?: string | null, product_title?: string | null, product_categorylevel1?: string | null, product_categorylevel2?: string | null, product_categorylevel3?: string | null, product_categorylevel?: number | null, product_retailerId?: string | null, product_additionalImageUrl?: Array<string | null> | null, product_productGroupId?: string | null, product_categoryId?: string | null, product_isPurchasableOnline?: boolean | null, product_multiVariant?: boolean | null, product_multiPrice?: boolean | null, product_advertLookUp?: string | null, product_brand?: string | null, product_productGroup?: { __typename?: 'productGroup', productGroup_type?: ProductGroupType | null, productGroup_displayName?: string | null, productGroup_forbiddenPostCodes?: Array<string | null> | null } | null, product_retailer?: { __typename?: 'retailer', retailer_colour?: string | null, retailer_logoUrl?: string | null, retailer_id?: string | null, retailer_displayName?: string | null, retailer_logoUrlSmall?: string | null, retailer_logoUrlLarge?: string | null, retailer_requireOverAgeCheck?: boolean | null, retailer_metadataTitleRetailer?: string | null, retailer_metadataDescriptionRetailer?: string | null, retailer_metadataTitleProductGroup?: string | null, retailer_metadataDescriptionProductGroup?: string | null, retailer_websiteURL?: string | null, retailer_deliveryMethod?: RetailerDeliveryMethod | null, retailer_shippingEstimationMessage?: string | null } | null } | null> | null } };

export type GetProductsMinimalFieldsQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProductsMinimalFieldsQuery = { __typename?: 'Query', getProducts: { __typename: 'error' } | { __typename: 'productList', total?: number | null, items?: Array<{ __typename: 'product', product_id?: string | null, product_advertLookUp?: string | null, product_name?: string | null, product_hideDate?: boolean | null, product_endDate?: string | null, product_isDuplicate?: boolean | null, product_retailer?: { __typename?: 'retailer', retailer_displayName?: string | null } | null } | null> | null } };

export type GetProductsForSearchQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  productFilters?: InputMaybe<InputProductFilters>;
}>;


export type GetProductsForSearchQuery = { __typename?: 'Query', getProductsForSearch: { __typename: 'error' } | { __typename: 'productList', total?: number | null, items?: Array<{ __typename: 'product', product_id?: string | null, product_price?: number | null, product_salePrice?: number | null, product_uomDescription?: string | null, product_description?: string | null, product_shippingDescription?: string | null, product_savingsPercentage?: number | null, product_buyNow?: boolean | null, product_name?: string | null, product_imageUrl?: string | null, product_hideDate?: boolean | null, product_endDate?: string | null, product_onPage?: number | null, product_inWishList?: boolean | null, product_imageMap?: string | null, product_isDuplicate?: boolean | null, product_isHidden?: boolean | null, product_startDate?: string | null, product_savingsAbsolute?: number | null, product_linkUrl?: string | null, product_title?: string | null, product_categorylevel1?: string | null, product_categorylevel2?: string | null, product_categorylevel3?: string | null, product_categorylevel?: number | null, product_retailerId?: string | null, product_additionalImageUrl?: Array<string | null> | null, product_productGroupId?: string | null, product_categoryId?: string | null, product_isPurchasableOnline?: boolean | null, product_multiVariant?: boolean | null, product_multiPrice?: boolean | null, product_advertLookUp?: string | null, product_brand?: string | null, product_productGroup?: { __typename?: 'productGroup', productGroup_type?: ProductGroupType | null, productGroup_displayName?: string | null, productGroup_forbiddenPostCodes?: Array<string | null> | null } | null, product_retailer?: { __typename?: 'retailer', retailer_colour?: string | null, retailer_logoUrl?: string | null, retailer_id?: string | null, retailer_displayName?: string | null, retailer_logoUrlSmall?: string | null, retailer_logoUrlLarge?: string | null, retailer_requireOverAgeCheck?: boolean | null, retailer_metadataTitleRetailer?: string | null, retailer_metadataDescriptionRetailer?: string | null, retailer_metadataTitleProductGroup?: string | null, retailer_metadataDescriptionProductGroup?: string | null, retailer_websiteURL?: string | null, retailer_deliveryMethod?: RetailerDeliveryMethod | null, retailer_shippingEstimationMessage?: string | null } | null } | null> | null } };

export type GetRetailersQueryVariables = Exact<{
  sortOrder?: InputMaybe<SortOrder>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  productFilters?: InputMaybe<InputProductFilters>;
  filterbyRetailerName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRetailersQuery = { __typename?: 'Query', getRetailers: { __typename?: 'error', error_code?: string | null, error_message?: string | null } | { __typename: 'retailerList', total?: number | null, items?: Array<{ __typename?: 'retailer', retailer_colour?: string | null, retailer_logoUrl?: string | null, retailer_id?: string | null, retailer_displayName?: string | null, retailer_logoUrlSmall?: string | null, retailer_logoUrlLarge?: string | null, retailer_requireOverAgeCheck?: boolean | null, retailer_metadataTitleRetailer?: string | null, retailer_metadataDescriptionRetailer?: string | null, retailer_metadataTitleProductGroup?: string | null, retailer_metadataDescriptionProductGroup?: string | null, retailer_websiteURL?: string | null, retailer_deliveryMethod?: RetailerDeliveryMethod | null } | null> | null } };

export type GetSimilarProductsQueryVariables = Exact<{
  productId: Scalars['String']['input'];
  exactMatch?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSimilarProductsQuery = { __typename?: 'Query', getSimilarProducts: { __typename: 'error' } | { __typename: 'productList', total?: number | null, retailerCount?: number | null, items?: Array<{ __typename: 'product', product_id?: string | null, product_price?: number | null, product_salePrice?: number | null, product_uomDescription?: string | null, product_description?: string | null, product_shippingDescription?: string | null, product_savingsPercentage?: number | null, product_buyNow?: boolean | null, product_name?: string | null, product_imageUrl?: string | null, product_hideDate?: boolean | null, product_endDate?: string | null, product_onPage?: number | null, product_inWishList?: boolean | null, product_imageMap?: string | null, product_isDuplicate?: boolean | null, product_isHidden?: boolean | null, product_startDate?: string | null, product_savingsAbsolute?: number | null, product_linkUrl?: string | null, product_title?: string | null, product_categorylevel1?: string | null, product_categorylevel2?: string | null, product_categorylevel3?: string | null, product_categorylevel?: number | null, product_retailerId?: string | null, product_additionalImageUrl?: Array<string | null> | null, product_productGroupId?: string | null, product_categoryId?: string | null, product_isPurchasableOnline?: boolean | null, product_multiVariant?: boolean | null, product_multiPrice?: boolean | null, product_advertLookUp?: string | null, product_brand?: string | null, product_productGroup?: { __typename?: 'productGroup', productGroup_type?: ProductGroupType | null, productGroup_displayName?: string | null, productGroup_forbiddenPostCodes?: Array<string | null> | null } | null, product_retailer?: { __typename?: 'retailer', retailer_colour?: string | null, retailer_logoUrl?: string | null, retailer_id?: string | null, retailer_displayName?: string | null, retailer_logoUrlSmall?: string | null, retailer_logoUrlLarge?: string | null, retailer_requireOverAgeCheck?: boolean | null, retailer_metadataTitleRetailer?: string | null, retailer_metadataDescriptionRetailer?: string | null, retailer_metadataTitleProductGroup?: string | null, retailer_metadataDescriptionProductGroup?: string | null, retailer_websiteURL?: string | null, retailer_deliveryMethod?: RetailerDeliveryMethod | null, retailer_shippingEstimationMessage?: string | null } | null } | null> | null } };

export type GetTopTenCataloguesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTopTenCataloguesQuery = { __typename?: 'Query', getTopTenCatalogues: { __typename: 'error', error_code?: string | null, error_message?: string | null } | { __typename: 'productGroupList', items?: Array<{ __typename: 'productGroup', productGroup_productGroupId?: string | null, productGroup_displayName?: string | null, productGroup_productGroupImage?: string | null, productGroup_thumbnailUrl?: string | null, productGroup_retailerId?: string | null, productGroup_type?: ProductGroupType | null, productGroup_productsTotal?: number | null, productGroup_pageLinks?: Array<{ __typename: 'pageLink', pageNumber?: string | null, imagePath?: string | null } | null> | null, productGroup_retailer?: { __typename?: 'retailer', retailer_colour?: string | null, retailer_logoUrl?: string | null, retailer_id?: string | null, retailer_displayName?: string | null, retailer_logoUrlSmall?: string | null, retailer_logoUrlLarge?: string | null, retailer_requireOverAgeCheck?: boolean | null, retailer_metadataTitleRetailer?: string | null, retailer_metadataDescriptionRetailer?: string | null, retailer_metadataTitleProductGroup?: string | null, retailer_metadataDescriptionProductGroup?: string | null, retailer_websiteURL?: string | null, retailer_deliveryMethod?: RetailerDeliveryMethod | null } | null } | null> | null } };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', getUserProfile?: { __typename: 'error', error_message?: string | null } | { __typename: 'user', userId?: string | null, mobile?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, isOver18?: boolean | null, signupCompleted?: boolean | null, signupDate?: string | null, preferences?: { __typename?: 'userPreferences', postCodes?: Array<string | null> | null, retailers?: Array<string | null> | null, categories?: Array<string | null> | null, brands?: Array<string | null> | null, notifications?: { __typename?: 'notificationPreferences', enableNotifications?: boolean | null, enableAppNotifications?: boolean | null, enableEmailNotifications?: boolean | null, enableSMSNotifications?: boolean | null } | null } | null } | null };

export type GetVariantsForAdvertQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetVariantsForAdvertQuery = { __typename?: 'Query', getVariantsForAdvert?: { __typename: 'advertVariantList', editablePrice?: string | null, editableSalePrice?: string | null, totalDomesticShippingCostCents?: number | null, total?: number | null, items?: Array<{ __typename?: 'advertVariant', available?: boolean | null, buyable?: boolean | null, countOnHand?: number | null, infiniteQuantity?: boolean | null, editablePrice?: number | null, editableSalePrice?: number | null, id?: string | null, imageUrls?: Array<string | null> | null, label?: string | null, published?: boolean | null, recommendedRetailPrice?: number | null, sku?: string | null, wholesalePrice?: string | null, optionValues?: Array<string | null> | null } | null> | null, aoStockCodes?: Array<{ __typename: 'AoStock', key?: StateEnum | null, value?: number | null } | null> | null } | { __typename: 'error', error_message?: string | null } | null };

export type GetWishListsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWishListsQuery = { __typename?: 'Query', getWishLists?: { __typename?: 'error' } | { __typename: 'wishLists', total?: number | null, items?: Array<{ __typename: 'wishList', id?: string | null, name?: string | null, productIds?: Array<string | null> | null } | null> | null } | null };

export type GetWishListsFullQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWishListsFullQuery = { __typename?: 'Query', getWishLists?: { __typename?: 'error' } | { __typename: 'wishLists', total?: number | null, items?: Array<{ __typename: 'wishList', id?: string | null, name?: string | null, productIds?: Array<string | null> | null, products?: Array<{ __typename: 'product', product_id?: string | null, product_price?: number | null, product_salePrice?: number | null, product_uomDescription?: string | null, product_description?: string | null, product_shippingDescription?: string | null, product_savingsPercentage?: number | null, product_buyNow?: boolean | null, product_name?: string | null, product_imageUrl?: string | null, product_hideDate?: boolean | null, product_endDate?: string | null, product_onPage?: number | null, product_inWishList?: boolean | null, product_imageMap?: string | null, product_isDuplicate?: boolean | null, product_isHidden?: boolean | null, product_startDate?: string | null, product_savingsAbsolute?: number | null, product_linkUrl?: string | null, product_title?: string | null, product_categorylevel1?: string | null, product_categorylevel2?: string | null, product_categorylevel3?: string | null, product_categorylevel?: number | null, product_retailerId?: string | null, product_additionalImageUrl?: Array<string | null> | null, product_productGroupId?: string | null, product_categoryId?: string | null, product_isPurchasableOnline?: boolean | null, product_multiVariant?: boolean | null, product_multiPrice?: boolean | null, product_advertLookUp?: string | null, product_brand?: string | null, product_productGroup?: { __typename?: 'productGroup', productGroup_type?: ProductGroupType | null, productGroup_displayName?: string | null, productGroup_forbiddenPostCodes?: Array<string | null> | null } | null, product_retailer?: { __typename?: 'retailer', retailer_colour?: string | null, retailer_logoUrl?: string | null, retailer_id?: string | null, retailer_displayName?: string | null, retailer_logoUrlSmall?: string | null, retailer_logoUrlLarge?: string | null, retailer_requireOverAgeCheck?: boolean | null, retailer_metadataTitleRetailer?: string | null, retailer_metadataDescriptionRetailer?: string | null, retailer_metadataTitleProductGroup?: string | null, retailer_metadataDescriptionProductGroup?: string | null, retailer_websiteURL?: string | null, retailer_deliveryMethod?: RetailerDeliveryMethod | null, retailer_shippingEstimationMessage?: string | null } | null } | null> | null } | null> | null } | null };

export type ValidateCartDeliveryQueryVariables = Exact<{
  customerPostcode: Scalars['String']['input'];
  productIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type ValidateCartDeliveryQuery = { __typename?: 'Query', validateCartDelivery?: { __typename: 'error', error_code?: string | null, error_message?: string | null } | { __typename: 'productDeliveryStatus', items?: Array<{ __typename: 'productItemDeliveryStatus', productId: number, deliverable: boolean }> | null } | null };

export type SubscribeCartSubscriptionVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;


export type SubscribeCartSubscription = { __typename?: 'Subscription', subscribeCart?: { __typename: 'cart', id?: string | null, billingCompanyName?: string | null, billingEmailAddress?: string | null, billingFirstName?: string | null, billingPhone?: string | null, billingSurname?: string | null, buyableQuantity?: number | null, messageToGiftRecipient?: string | null, messageToSeller?: string | null, shippingCostCents?: number | null, taxTotalCents?: number | null, createdAt?: string | null, couponCode?: string | null, discountCents?: number | null, subtotalCents?: number | null, totalCents?: number | null, cartSellers?: Array<{ __typename?: 'cartSeller', id?: string | null, baseDomesticShippingCost?: number | null, businessName?: string | null, domesticShippingFreeThreshold?: number | null, cartItemDeliveryMethodGroup?: Array<{ __typename?: 'cartItemDeliveryMethodGroup', deliveryMethod?: DeliveryMethod | null, discountCents?: number | null, shippingCostCents?: number | null, subtotalCents?: number | null, taxTotalCents?: number | null, totalCents?: number | null, shippingDescription?: string | null } | null> | null } | null> | null, address?: { __typename?: 'cartAddress', address?: string | null, city?: string | null, fullAddress?: string | null, postcode?: string | null, state?: string | null, subaddress?: string | null, country?: { __typename?: 'cartCountry', code?: string | null, name?: string | null } | null } | null, billingAddress?: { __typename?: 'cartAddress', address?: string | null, city?: string | null, fullAddress?: string | null, postcode?: string | null, state?: string | null, subaddress?: string | null, country?: { __typename?: 'cartCountry', code?: string | null, name?: string | null } | null } | null, items?: Array<{ __typename: 'cartItem', id?: string | null, deliveryMethod?: DeliveryMethod | null, discountCents?: number | null, hasFreeShippingDiscount?: boolean | null, internationalShippingAvailable?: boolean | null, internationalShippingRequired?: boolean | null, quantity?: number | null, shippingCostCents?: number | null, subtotalCents?: number | null, productId?: number | null, totalCents?: number | null, status?: CartItemStatus | null, seller?: { __typename?: 'sellerDetail', baseDomesticShippingCost?: number | null, businessName?: string | null, deliveryDetails?: string | null, domesticShippingFreeThreshold?: number | null, emailAddress?: string | null, id?: string | null, mailToUrl?: string | null, obscuredPhone?: string | null, phone?: string | null, returnPolicy?: string | null, sellerIsContactable?: boolean | null, servicePolicy?: string | null, showPhoneNumber?: boolean | null, underAdDescription?: string | null, underAdImpressum?: string | null } | null, advert?: { __typename?: 'advert', brand?: string | null, brandName?: string | null, category?: string | null, description?: string | null, displayImage?: string | null, editablePrice?: string | null, editableSalePrice?: string | null, fullTitle?: string | null, id?: string | null, sellerId?: string | null, title?: string | null, aoStockCodes?: Array<{ __typename: 'AoStock', key?: StateEnum | null, value?: number | null } | null> | null } | null, product?: { __typename: 'product', product_id?: string | null, product_price?: number | null, product_salePrice?: number | null, product_uomDescription?: string | null, product_description?: string | null, product_shippingDescription?: string | null, product_savingsPercentage?: number | null, product_buyNow?: boolean | null, product_name?: string | null, product_imageUrl?: string | null, product_hideDate?: boolean | null, product_endDate?: string | null, product_onPage?: number | null, product_inWishList?: boolean | null, product_imageMap?: string | null, product_isDuplicate?: boolean | null, product_isHidden?: boolean | null, product_startDate?: string | null, product_savingsAbsolute?: number | null, product_linkUrl?: string | null, product_title?: string | null, product_categorylevel1?: string | null, product_categorylevel2?: string | null, product_categorylevel3?: string | null, product_categorylevel?: number | null, product_retailerId?: string | null, product_additionalImageUrl?: Array<string | null> | null, product_productGroupId?: string | null, product_categoryId?: string | null, product_brand?: string | null, product_productGroup?: { __typename?: 'productGroup', productGroup_type?: ProductGroupType | null, productGroup_displayName?: string | null, productGroup_forbiddenPostCodes?: Array<string | null> | null } | null, product_retailer?: { __typename?: 'retailer', retailer_colour?: string | null, retailer_logoUrl?: string | null, retailer_id?: string | null, retailer_displayName?: string | null, retailer_logoUrlSmall?: string | null, retailer_logoUrlLarge?: string | null, retailer_requireOverAgeCheck?: boolean | null, retailer_metadataTitleRetailer?: string | null, retailer_metadataDescriptionRetailer?: string | null, retailer_metadataTitleProductGroup?: string | null, retailer_metadataDescriptionProductGroup?: string | null, retailer_websiteURL?: string | null, retailer_deliveryMethod?: RetailerDeliveryMethod | null, retailer_shippingEstimationMessage?: string | null } | null } | null, variant?: { __typename?: 'advertVariant', available?: boolean | null, buyable?: boolean | null, countOnHand?: number | null, infiniteQuantity?: boolean | null, editablePrice?: number | null, editableSalePrice?: number | null, id?: string | null, imageUrls?: Array<string | null> | null, label?: string | null, published?: boolean | null, recommendedRetailPrice?: number | null, sku?: string | null, wholesalePrice?: string | null } | null } | null> | null } | { __typename: 'error', error_code?: string | null, error_message?: string | null } | null };

export const BrandParts = gql`
    fragment BrandParts on brand {
  __typename
  brand_name
  brand_productCount
  brand_brandId
  brand_displayName
  brand_logoUrl
  brand_logoUrlSmall
  brand_logoUrlLarge
  brand_logoColor
  brand_sponsorUrl
  brand_sponsorText
  brand_keyword
  brand_fashion
  brand_order
  brand_tier1
  brand_availableForPreference
}
    `;
export const CartSellersPart = gql`
    fragment CartSellersPart on cartSeller {
  id
  baseDomesticShippingCost
  businessName
  domesticShippingFreeThreshold
  cartItemDeliveryMethodGroup {
    deliveryMethod
    discountCents
    shippingCostCents
    subtotalCents
    taxTotalCents
    totalCents
    shippingDescription
  }
}
    `;
export const AddressParts = gql`
    fragment AddressParts on cartAddress {
  address
  city
  country {
    code
    name
  }
  fullAddress
  postcode
  state
  subaddress
}
    `;
export const SellerParts = gql`
    fragment SellerParts on sellerDetail {
  baseDomesticShippingCost
  businessName
  deliveryDetails
  domesticShippingFreeThreshold
  emailAddress
  id
  mailToUrl
  obscuredPhone
  phone
  returnPolicy
  sellerIsContactable
  servicePolicy
  showPhoneNumber
  underAdDescription
  underAdImpressum
}
    `;
export const AdvertParts = gql`
    fragment AdvertParts on advert {
  brand
  brandName
  category
  description
  displayImage
  editablePrice
  editableSalePrice
  fullTitle
  id
  sellerId
  title
  aoStockCodes {
    key
    value
    __typename
  }
}
    `;
export const RetailerParts = gql`
    fragment RetailerParts on retailer {
  retailer_colour
  retailer_logoUrl
  retailer_id
  retailer_displayName
  retailer_logoUrlSmall
  retailer_logoUrlLarge
  retailer_requireOverAgeCheck
  retailer_metadataTitleRetailer
  retailer_metadataDescriptionRetailer
  retailer_metadataTitleProductGroup
  retailer_metadataDescriptionProductGroup
  retailer_websiteURL
  retailer_deliveryMethod
}
    `;
export const ProductParts = gql`
    fragment ProductParts on product {
  __typename
  product_id
  product_price
  product_salePrice
  product_uomDescription
  product_description
  product_shippingDescription
  product_savingsPercentage
  product_brand: product_brandId
  product_buyNow
  product_name
  product_imageUrl
  product_hideDate
  product_endDate
  product_onPage
  product_inWishList
  product_imageMap
  product_isDuplicate
  product_isHidden
  product_startDate
  product_savingsAbsolute
  product_linkUrl
  product_startDate
  product_title
  product_categorylevel1
  product_categorylevel2
  product_categorylevel3
  product_categorylevel
  product_retailerId
  product_additionalImageUrl
  product_productGroupId
  product_categoryId
  product_productGroup {
    productGroup_type
    productGroup_displayName
    productGroup_forbiddenPostCodes
  }
  product_retailer {
    ...RetailerParts
    retailer_shippingEstimationMessage
  }
}
    ${RetailerParts}`;
export const VariantParts = gql`
    fragment VariantParts on advertVariant {
  available
  buyable
  countOnHand
  infiniteQuantity
  editablePrice
  editableSalePrice
  id
  imageUrls
  label
  published
  recommendedRetailPrice
  sku
  wholesalePrice
}
    `;
export const CartItemParts = gql`
    fragment CartItemParts on cartItem {
  __typename
  id
  deliveryMethod
  discountCents
  hasFreeShippingDiscount
  internationalShippingAvailable
  internationalShippingRequired
  quantity
  shippingCostCents
  subtotalCents
  productId
  totalCents
  status
  seller {
    ...SellerParts
  }
  advert {
    ...AdvertParts
  }
  product {
    ...ProductParts
  }
  variant {
    ...VariantParts
  }
}
    ${SellerParts}
${AdvertParts}
${ProductParts}
${VariantParts}`;
export const CartParts = gql`
    fragment CartParts on cart {
  __typename
  id
  billingCompanyName
  billingEmailAddress
  billingFirstName
  billingPhone
  billingSurname
  buyableQuantity
  messageToGiftRecipient
  messageToSeller
  shippingCostCents
  taxTotalCents
  createdAt
  cartSellers {
    ...CartSellersPart
  }
  couponCode
  discountCents
  subtotalCents
  totalCents
  address {
    ...AddressParts
  }
  billingAddress {
    ...AddressParts
  }
  items {
    ... on cartItem {
      ...CartItemParts
    }
  }
}
    ${CartSellersPart}
${AddressParts}
${CartItemParts}`;
export const CatalogueMetaDataParts = gql`
    fragment CatalogueMetaDataParts on productGroupMetadata {
  productGroupMetadata_imageMap
  productGroupMetadata_metadataId
  productGroupMetadata_pageNo
  productGroupMetadata_type
  productGroupMetadata_productGroupId
  productGroupMetadata_displayName
  productGroupMetadata_imageMap
  productGroupMetadata_name
  productGroupMetadata_offerId
  productGroupMetadata_imagePath
  productGroupMetadata_metaText
  productGroupMetadata_videoUrl
  productGroupMetadata_metaUrl
  productGroupMetadata_linkToPage
}
    `;
export const OrderParts = gql`
    fragment OrderParts on order {
  id
  total
  address {
    ...AddressParts
  }
  aggregateInvoiceStatusFinal
  billingAddress {
    ...AddressParts
  }
  billingCompanyName
  billingEmailAddress
  billingFirstName
  billingPhone
  billingSurname
  companyName
  createdAt
  updatedAt
  discountCents
  emailAddress
  expectedDeliveryDate
  expectedDeliverySlot
  firstName
  isGift
  messageToGiftRecipient
  messageToSeller
  paymentGatewayDetails
  paymentInstrumentType
  permalink
  phone
  shippingCostCents
  status
  subtotal
  subtotalCents
  surname
  taxTotal
  taxTotalCents
  token
  totalCents
}
    ${AddressParts}`;
export const LineItemParts = gql`
    fragment LineItemParts on lineItem {
  advertCode
  advertId
  advertTitle
  discountCents
  id
  image
  inventory {
    countOnHand
    id
    infiniteQuantity
    price
    salePrice
    seller {
      ...SellerParts
    }
  }
  postageCents
  productId
  quantity
  quantityAwaitingDispatch
  shipments {
    carrier
    createdAt
    dispatchedAt
    id
    trackingLink
    trackingNumber
    updatedAt
  }
  statusFull
  subtotalCents
  taxTotalCents
  totalCents
  variantBarcode
  variantId
  variantName
  variantSku
}
    ${SellerParts}`;
export const RetailerCartParts = gql`
    fragment RetailerCartParts on retailerDetail {
  displayName
  isPublished
  color
  logoUrl
  logoUrlLarge
  logoUrlSmall
  name
  retailerCategories
  retailerId
  shippingEstimationMessage
  websiteURL
}
    `;
export const OrderInvoiceParts = gql`
    fragment OrderInvoiceParts on invoice {
  buyerBillingAddress {
    ...AddressParts
  }
  buyerEmailAddress
  buyerFirstName
  buyerMessageToSeller
  buyerPhone
  buyerSurname
  id
  lineItems {
    ...LineItemParts
  }
  seller {
    ...SellerParts
  }
  retailer {
    ...RetailerCartParts
  }
  paidAt
  paymentInstrumentType
  pdfLink
  shippingCostCents
  shippingDescription
  shippingFromLocationMessage
  statusFlags
  subtotalCents
  taxShippingCents
  taxTotalCents
  totalCents
}
    ${AddressParts}
${LineItemParts}
${SellerParts}
${RetailerCartParts}`;
export const ProductECommerceParts = gql`
    fragment ProductECommerceParts on product {
  product_isPurchasableOnline
  product_multiVariant
  product_multiPrice
  product_advertLookUp
}
    `;
export const AddItemToCart = gql`
    mutation addItemToCart($clientMutationId: String, $deliveryMethod: DeliveryMethod!, $productId: Int!, $quantity: Int!, $variantBarcode: String, $variantId: String!, $advertId: String!, $cartId: String) {
  addItemToCart(
    clientMutationId: $clientMutationId
    deliveryMethod: $deliveryMethod
    productId: $productId
    advertId: $advertId
    quantity: $quantity
    variantId: $variantId
    variantBarcode: $variantBarcode
    cartId: $cartId
  ) {
    __typename
    ... on cart {
      __typename
      ...CartParts
    }
    ... on error {
      __typename
      error_code
      error_message
    }
  }
}
    ${CartParts}`;
export const AddToWishList = gql`
    mutation addToWishList($productId: String) {
  addToWishList(productId: $productId) {
    ... on wishLists {
      __typename
      total
      items {
        __typename
        id
        name
        productIds
      }
    }
  }
}
    `;
export const DeleteItemFromCart = gql`
    mutation deleteItemFromCart($id: String!, $cartId: String) {
  deleteItemFromCart(id: $id, cartId: $cartId) {
    ... on cart {
      ...CartParts
      __typename
    }
    ... on error {
      __typename
      error_message
      error_code
    }
  }
}
    ${CartParts}`;
export const DeleteUser = gql`
    mutation deleteUser {
  deleteUser {
    ... on deletedUser {
      __typename
      deletedUserId
    }
    ... on error {
      __typename
      error_message
      error_code
    }
  }
}
    `;
export const PlaceOrderCheckout = gql`
    mutation placeOrderCheckout($params: inputCheckoutParams!, $cartId: String) {
  checkout(cartId: $cartId, params: $params) {
    ... on order {
      __typename
      aggregateInvoiceStatusFinal
      billingCompanyName
      billingEmailAddress
      billingFirstName
      billingPhone
      billingSurname
      companyName
      createdAt
      discountCents
      emailAddress
      expectedDeliveryDate
      expectedDeliverySlot
      firstName
      id
      invoices {
        buyerBillingAddress {
          ...AddressParts
        }
        buyerEmailAddress
        buyerFirstName
        buyerMessageToSeller
        buyerPhone
        buyerSurname
        id
        lineItems {
          advertCode
          advertId
          advertTitle
          discountCents
          id
          image
          postageCents
          quantity
          quantityAwaitingDispatch
          shipments {
            carrier
            createdAt
            dispatchedAt
            id
            trackingLink
            trackingNumber
            updatedAt
          }
          statusFull
          subtotalCents
          taxTotalCents
          totalCents
          variantBarcode
          variantId
          variantName
          variantSku
        }
        seller {
          ...SellerParts
        }
        retailer {
          ...RetailerCartParts
        }
        paidAt
        paymentInstrumentType
        pdfLink
        shippingCostCents
        shippingDescription
        shippingFromLocationMessage
        statusFlags
        subtotalCents
        taxShippingCents
        taxTotalCents
        totalCents
      }
      isGift
      messageToGiftRecipient
      messageToSeller
      paymentGatewayDetails
      paymentInstrumentType
      permalink
      phone
      shippingCostCents
      status
      subtotal
      subtotalCents
      surname
      taxTotal
      taxTotalCents
      token
      total
      totalCents
      updatedAt
    }
    ... on userActionError {
      __typename
      error_message
      error_title
      navigate_to
    }
    ... on error {
      __typename
      error_code
      error_message
    }
  }
}
    ${AddressParts}
${SellerParts}
${RetailerCartParts}`;
export const PlaceOrderCheckoutWithRedirect = gql`
    mutation placeOrderCheckoutWithRedirect($params: inputCheckoutParams!, $cartId: String) {
  checkoutWithRedirection(cartId: $cartId, params: $params) {
    ... on checkoutWithRedirectionResponse {
      __typename
      redirectUrl
      order {
        __typename
        aggregateInvoiceStatusFinal
        billingCompanyName
        billingEmailAddress
        billingFirstName
        billingPhone
        billingSurname
        companyName
        createdAt
        discountCents
        emailAddress
        expectedDeliveryDate
        expectedDeliverySlot
        firstName
        id
        invoices {
          buyerBillingAddress {
            ...AddressParts
          }
          buyerEmailAddress
          buyerFirstName
          buyerMessageToSeller
          buyerPhone
          buyerSurname
          id
          lineItems {
            advertCode
            advertId
            advertTitle
            discountCents
            id
            image
            postageCents
            quantity
            quantityAwaitingDispatch
            shipments {
              carrier
              createdAt
              dispatchedAt
              id
              trackingLink
              trackingNumber
              updatedAt
            }
            statusFull
            subtotalCents
            taxTotalCents
            totalCents
            variantBarcode
            variantId
            variantName
            variantSku
          }
          seller {
            ...SellerParts
          }
          retailer {
            ...RetailerCartParts
          }
          paidAt
          paymentInstrumentType
          pdfLink
          shippingCostCents
          shippingDescription
          shippingFromLocationMessage
          statusFlags
          subtotalCents
          taxShippingCents
          taxTotalCents
          totalCents
        }
        isGift
        messageToGiftRecipient
        messageToSeller
        paymentGatewayDetails
        paymentInstrumentType
        permalink
        phone
        shippingCostCents
        status
        subtotal
        subtotalCents
        surname
        taxTotal
        taxTotalCents
        token
        total
        totalCents
        updatedAt
      }
    }
    ... on error {
      __typename
      error_code
      error_message
    }
  }
}
    ${AddressParts}
${SellerParts}
${RetailerCartParts}`;
export const ProcessPaymentGatewayRedirect = gql`
    mutation processPaymentGatewayRedirect($input: processPaymentGatewayRedirectMutationInput!) {
  processPaymentGatewayRedirect(input: $input) {
    ... on processPaymentGatewayRedirect {
      __typename
      clientMutationId
      order {
        aggregateInvoiceStatusFinal
        billingCompanyName
        billingEmailAddress
        billingFirstName
        billingPhone
        billingSurname
        companyName
        createdAt
        discountCents
        emailAddress
        expectedDeliveryDate
        expectedDeliverySlot
        firstName
        id
        invoices {
          buyerBillingAddress {
            ...AddressParts
          }
          buyerEmailAddress
          buyerFirstName
          buyerMessageToSeller
          buyerPhone
          buyerSurname
          id
          lineItems {
            advertCode
            advertId
            advertTitle
            discountCents
            id
            image
            postageCents
            quantity
            quantityAwaitingDispatch
            shipments {
              carrier
              createdAt
              dispatchedAt
              id
              trackingLink
              trackingNumber
              updatedAt
            }
            statusFull
            subtotalCents
            taxTotalCents
            totalCents
            variantBarcode
            variantId
            variantName
            variantSku
          }
          seller {
            ...SellerParts
          }
          retailer {
            ...RetailerCartParts
          }
          paidAt
          paymentInstrumentType
          pdfLink
          shippingCostCents
          shippingDescription
          shippingFromLocationMessage
          statusFlags
          subtotalCents
          taxShippingCents
          taxTotalCents
          totalCents
        }
        isGift
        messageToGiftRecipient
        messageToSeller
        paymentGatewayDetails
        paymentInstrumentType
        permalink
        phone
        shippingCostCents
        status
        subtotal
        subtotalCents
        surname
        taxTotal
        taxTotalCents
        token
        total
        totalCents
        updatedAt
      }
    }
    ... on error {
      __typename
      error_code
      error_message
    }
  }
}
    ${AddressParts}
${SellerParts}
${RetailerCartParts}`;
export const RemoveFromWishList = gql`
    mutation removeFromWishList($productId: String) {
  removeFromWishList(productId: $productId) {
    ... on wishLists {
      __typename
      total
      items {
        __typename
        id
        name
        productIds
      }
    }
  }
}
    `;
export const SaveUserProfile = gql`
    mutation saveUserProfile($inputUser: inputUser) {
  saveUserProfile(user: $inputUser) {
    ... on user {
      __typename
      mobile
      firstName
      lastName
      email
      mobile
      isOver18
      preferences {
        __typename
        postCodes
        retailers
        categories
        brands
        notifications {
          enableNotifications
          enableAppNotifications
          enableEmailNotifications
          enableSMSNotifications
        }
      }
    }
  }
}
    `;
export const UpdateCartItem = gql`
    mutation updateCartItem($clientMutationId: String, $deliveryMethod: DeliveryMethod, $id: String!, $quantity: Int, $advertId: String!, $productId: Int!, $variantId: String!, $cartId: String) {
  updateCartItem(
    clientMutationId: $clientMutationId
    deliveryMethod: $deliveryMethod
    id: $id
    quantity: $quantity
    advertId: $advertId
    productId: $productId
    variantId: $variantId
    cartId: $cartId
  ) {
    ... on cart {
      __typename
      ...CartParts
    }
    ... on error {
      __typename
      error_code
      error_message
    }
  }
}
    ${CartParts}`;
export const UpdateCartMetadata = gql`
    mutation updateCartMetadata($cartMetadata: cartMetadata) {
  updateCartMetadata(cartMetadata: $cartMetadata) {
    ... on successBool {
      isSuccess
    }
    ... on error {
      __typename
      error_code
      error_message
    }
  }
}
    `;
export const UpdateCartMetadataCoupon = gql`
    mutation updateCartMetadataCoupon($cartMetadata: cartMetadataCoupon) {
  updateCartMetadataCoupon(cartMetadata: $cartMetadata) {
    ... on cart {
      __typename
      ...CartParts
    }
    ... on error {
      __typename
      error_code
      error_message
    }
  }
}
    ${CartParts}`;
export const GetProductBrandsFromSearch = gql`
    query getProductBrandsFromSearch($from: Int, $limit: Int, $productFilters: inputProductFilters, $searchTerm: String) {
  getProductsForSearch(
    from: $from
    limit: $limit
    productFilters: $productFilters
    searchTerm: $searchTerm
  ) {
    ... on productList {
      __typename
      total
      brands {
        ...BrandParts
      }
    }
  }
}
    ${BrandParts}`;
export const GetAllBrandDetails = gql`
    query getAllBrandDetails($availableForPreference: Boolean, $filterbyBrands: [String], $sortOrder: sortOrder, $limit: Int, $from: Int) {
  getAllBrands(
    availableForPreference: $availableForPreference
    filterbyBrands: $filterbyBrands
    from: $from
    limit: $limit
    sortOrder: $sortOrder
  ) {
    ... on brandList {
      __typename
      total
      items {
        brand_logoColor
        brand_logoUrl
        brand_brandId
        brand_displayName
      }
    }
  }
}
    `;
export const GetAllBrands = gql`
    query getAllBrands($availableForPreference: Boolean, $filterbyBrands: [String], $sortOrder: sortOrder, $limit: Int, $from: Int) {
  getAllBrands(
    availableForPreference: $availableForPreference
    filterbyBrands: $filterbyBrands
    sortOrder: $sortOrder
    limit: $limit
    from: $from
  ) {
    ... on brandList {
      __typename
      total
      items {
        brand_logoUrl
        brand_brandId
        brand_logoColor
        brand_displayName
      }
    }
  }
}
    `;
export const GetAllCategories = gql`
    query getAllCategories($availableForPreference: Boolean, $filterbyCategories: [String], $from: Int, $limit: Int, $sortOrder: sortOrder) {
  getAllCategories(
    availableForPreference: $availableForPreference
    filterbyCategories: $filterbyCategories
    from: $from
    limit: $limit
    sortOrder: $sortOrder
  ) {
    ... on categoryList {
      __typename
      total
      items {
        category_categoryId
        category_friendlyName
        category_name
        category_thumbnailUrl
        category_tileUrl
        category_order
        category_level1
        category_level2
        category_level3
        category_categorylevel
        category_iconUrl
        category_mainCategoryBannerUrl
        category_mainCategoryBannerColor
        category_subCategoryBannerUrl
        category_subCategoryBannerColor
        category_seoKeywords
        category_richDescription
        category_metadataTitle
        category_metadataDescription
      }
    }
  }
}
    `;
export const GetAllRetailerDetails = gql`
    query getAllRetailerDetails($availableForPreference: Boolean, $filterbyRetailers: [String], $sortOrder: sortOrder, $limit: Int, $from: Int, $sortBy: String, $location: inputGeoloc, $filterbyRetailerName: String) {
  getAllRetailers(
    availableForPreference: $availableForPreference
    filterbyRetailers: $filterbyRetailers
    from: $from
    limit: $limit
    sortBy: $sortBy
    sortOrder: $sortOrder
    location: $location
    filterbyRetailerName: $filterbyRetailerName
  ) {
    ... on error {
      error_code
      error_message
    }
    ... on retailerList {
      __typename
      total
      items {
        ...RetailerParts
        retailer_description
        retailer_locations {
          addressLine1
          addressLine2
          addressLine3
          displayName
          storeHours {
            sunday {
              closeHours
              startHours
            }
            monday {
              closeHours
              startHours
            }
            tuesday {
              closeHours
              startHours
            }
            wednesday {
              closeHours
              startHours
            }
            thursday {
              closeHours
              startHours
            }
            friday {
              closeHours
              startHours
            }
            saturday {
              closeHours
              startHours
            }
          }
          locationId
          postCode
          state
          suburb
          geopoint {
            lat
            lon
          }
        }
      }
    }
  }
}
    ${RetailerParts}`;
export const GetAllRetailers = gql`
    query getAllRetailers($availableForPreference: Boolean, $tier1: Boolean, $filterbyRetailers: [String], $sortOrder: sortOrder, $limit: Int, $from: Int, $sortBy: String) {
  getAllRetailers(
    availableForPreference: $availableForPreference
    tier1: $tier1
    filterbyRetailers: $filterbyRetailers
    from: $from
    limit: $limit
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    ... on error {
      error_code
      error_message
    }
    ... on retailerList {
      __typename
      total
      items {
        ...RetailerParts
      }
    }
  }
}
    ${RetailerParts}`;
export const GetAutoComplete = gql`
    query getAutoComplete($searchterm: String) {
  getAutocomplete(searchterm: $searchterm) {
    __typename
    ... on autocomplete {
      total
      items
    }
  }
}
    `;
export const GetBasicAds = gql`
    query getBasicAds($position: AdPosition!) {
  getBasicAds(position: $position) {
    __typename
    ... on AdList {
      items {
        description
        endDate
        externalId
        id
        imageLarge
        imageLargePublic
        imageLink
        imageSmall
        imageSmallPublic
        orderDate
        position
        retailerCode
        startDate
        title
      }
    }
    ... on error {
      __typename
      error_code
      error_message
    }
  }
}
    `;
export const GetBrands = gql`
    query getBrands($sortOrder: sortOrder, $limit: Int, $from: Int, $searchTerm: String, $productFilters: inputProductFilters, $filterbyBrandName: String) {
  getBrands(
    filterbyBrandName: $filterbyBrandName
    sortOrder: $sortOrder
    limit: $limit
    searchTerm: $searchTerm
    productFilters: $productFilters
    from: $from
  ) {
    ... on brandList {
      __typename
      total
      items {
        brand_name
        brand_productCount
        brand_brandId
      }
    }
  }
}
    `;
export const GetCart = gql`
    query getCart($cartId: String) {
  getCart(cartId: $cartId) {
    ... on cart {
      ...CartParts
    }
    ... on error {
      __typename
      error_code
      error_message
    }
  }
}
    ${CartParts}`;
export const GetCartById = gql`
    query getCartById($cartId: String!) {
  getCartById(cartId: $cartId) {
    ... on cart {
      ...CartParts
    }
    ... on error {
      __typename
      error_code
      error_message
    }
  }
}
    ${CartParts}`;
export const GetCatalogueById = gql`
    query GetCatalogueById($id: String!) {
  getProductGroups(
    productFilters: {filterbyProductGroups: [$id]}
    from: 0
    limit: 1
  ) {
    __typename
    ... on error {
      error_code
      error_message
    }
    ... on productGroupList {
      items {
        productGroup_productGroupId
        productGroup_startDate
        productGroup_endDate
        productGroup_hideDate
        productGroup_linkUrl
        productGroup_numberOfPages
        productGroup_termsAndConditions
        productGroup_instructions
        productGroup_buyNow
        productGroup_isMarketplace
        productGroup_type
        productGroup_isBundle
        productGroup_productsTotal
        productGroup_displayName
        productGroup_productGroupImage
        productGroup_publicationDate
        productGroup_postcodes
        productGroup_forbiddenPostCodes
        productGroup_pageLinks {
          pageNumber
          imagePath
          __typename
        }
        productGroup_metadata {
          ...CatalogueMetaDataParts
        }
        productGroup_retailer {
          ...RetailerParts
        }
      }
    }
  }
}
    ${CatalogueMetaDataParts}
${RetailerParts}`;
export const GetCatalogues = gql`
    query GetCatalogues($random: String, $sortOrder: sortOrder, $limit: Int, $from: Int, $sortBy: String, $searchTerm: String, $productFilters: inputProductFilters, $trendingNow: Boolean) {
  getProductGroups(
    random: $random
    sortOrder: $sortOrder
    limit: $limit
    from: $from
    sortBy: $sortBy
    searchTerm: $searchTerm
    productFilters: $productFilters
    trendingNow: $trendingNow
  ) {
    __typename
    ... on productGroupList {
      total
      items {
        productGroup_productGroupImage
        productGroup_thumbnailUrl
        productGroup_productGroupId
        productGroup_endDate
        productGroup_hideDate
        productGroup_displayName
        productGroup_metadata {
          ...CatalogueMetaDataParts
        }
        productGroup_pageLinks {
          pageNumber
          imagePath
          __typename
        }
        productGroup_type
        productGroup_productsTotal
        productGroup_forbiddenPostCodes
        productGroup_retailer {
          ...RetailerParts
        }
      }
    }
  }
}
    ${CatalogueMetaDataParts}
${RetailerParts}`;
export const GetCategories = gql`
    query getCategories($from: Int, $limit: Int, $sortOrder: sortOrder, $context: categoryContext, $productFilters: inputProductFilters, $parentCategory: String, $searchTerm: String) {
  getCategories(
    from: $from
    limit: $limit
    sortOrder: $sortOrder
    context: $context
    productFilters: $productFilters
    parentCategory: $parentCategory
    searchTerm: $searchTerm
  ) {
    ... on categoryList {
      __typename
      items {
        category_categoryId
        category_categorylevel
        category_friendlyName
        category_level1
        category_level2
        category_level3
        category_name
        category_order
        category_thumbnailUrl
        category_tileUrl
        category_iconUrl
        category_mainCategoryBannerUrl
        category_mainCategoryBannerColor
        category_subCategoryBannerUrl
        category_subCategoryBannerColor
        category_seoKeywords
        category_richDescription
        category_metadataTitle
        category_metadataDescription
        category_hideFromMenu
      }
      total
    }
  }
}
    `;
export const GetCategoryByLevelName = gql`
    query getCategoryByLevelName($slug_1: String, $slug_2: String, $slug_3: String) {
  getCategoryByLevelName(slug_1: $slug_1, slug_2: $slug_2, slug_3: $slug_3) {
    ... on error {
      __typename
      error_code
      error_message
    }
    ... on category {
      __typename
      category_categorylevel
      category_productCount
      category_level1
      category_level2
      category_level3
      category_categoryId
      category_name
      category_friendlyName
      category_mainCategoryBannerUrl
      category_mainCategoryBannerColor
      category_subCategoryBannerUrl
      category_subCategoryBannerColor
      category_seoKeywords
      category_richDescription
      category_metadataDescription
      category_metadataTitle
      category_thumbnailUrl
    }
  }
}
    `;
export const GetCategoryDetailsById = gql`
    query getCategoryDetailsById($from: Int, $limit: Int, $sortOrder: sortOrder, $productFilters: inputProductFilters, $parentCategory: String) {
  getCategoryDetailsById(
    from: $from
    limit: $limit
    sortOrder: $sortOrder
    productFilters: $productFilters
    parentCategory: $parentCategory
  ) {
    ... on error {
      __typename
      error_code
      error_message
    }
    ... on categoryList {
      __typename
      items {
        category_categoryId
        category_categorylevel
        category_friendlyName
        category_level1
        category_level2
        category_level3
        category_name
        category_order
        category_thumbnailUrl
        category_tileUrl
        category_iconUrl
        category_mainCategoryBannerUrl
        category_mainCategoryBannerColor
        category_subCategoryBannerUrl
        category_subCategoryBannerColor
        category_seoKeywords
        category_richDescription
        category_metadataDescription
        category_metadataTitle
      }
    }
  }
}
    `;
export const GetFeatures = gql`
    query getFeatures {
  getFeatures {
    __typename
    ... on features {
      __typename
      items
      config
    }
    ... on error {
      __typename
      error_code
      error_message
    }
  }
}
    `;
export const GetInventoryForFirstVariant = gql`
    query GetInventoryForFirstVariant($advertId: ID!) {
  getInventoryForFirstVariant(advertId: $advertId) {
    __typename
    ... on inventoryStatus {
      id
      available
    }
    ... on error {
      error_code
      error_message
    }
  }
}
    `;
export const GetInventoryForVariant = gql`
    query GetInventoryForVariant($advertId: ID!, $variantId: ID!) {
  getInventoryForVariant(advertId: $advertId, variantId: $variantId) {
    __typename
    ... on inventoryStatus {
      __typename
      id
      available
    }
    ... on error {
      __typename
      error_code
      error_message
    }
  }
}
    `;
export const GetOrder = gql`
    query getOrder($permalink: String!) {
  getOrder(permalink: $permalink) {
    __typename
    ... on order {
      ...OrderParts
      invoices {
        id
        lineItems {
          advertCode
          advertId
          advertTitle
          discountCents
          id
          image
          postageCents
          productId
          quantity
          quantityAwaitingDispatch
          shipments {
            carrier
            createdAt
            dispatchedAt
            id
            trackingLink
            trackingNumber
            updatedAt
          }
          statusFull
          subtotalCents
          taxTotalCents
          totalCents
          variantBarcode
          variantId
          variantName
          variantSku
        }
        seller {
          ...SellerParts
        }
        retailer {
          ...RetailerCartParts
        }
        paidAt
        paymentInstrumentType
        pdfLink
        shippingCostCents
        shippingDescription
        shippingFromLocationMessage
        statusFlags
        subtotalCents
        taxShippingCents
        taxTotalCents
        totalCents
      }
    }
    ... on error {
      error_code
      error_message
    }
  }
}
    ${OrderParts}
${SellerParts}
${RetailerCartParts}`;
export const GetOrders = gql`
    query getOrders {
  getOrders {
    ... on orderList {
      __typename
      items {
        ...OrderParts
        invoices {
          lineItems {
            advertTitle
            quantity
            image
          }
        }
      }
    }
    ... on error {
      __typename
      error_code
      error_message
    }
  }
}
    ${OrderParts}`;
export const GetPaymentToken = gql`
    query getPaymentToken {
  getPaymentToken {
    __typename
    ... on paymentToken {
      paymentToken
    }
    ... on error {
      error_code
      error_message
    }
  }
}
    `;
export const GetPremiumAds = gql`
    query getPremiumAds {
  getPremiumAds {
    __typename
    ... on AdList {
      items {
        description
        endDate
        externalId
        id
        imageLarge
        imageLargePublic
        imageLink
        imageSmall
        imageSmallPublic
        orderDate
        position
        retailerCode
        startDate
        title
      }
    }
    ... on error {
      __typename
      error_code
      error_message
    }
  }
}
    `;
export const GetProductVariantImages = gql`
    query GetProductVariantImages($advertId: String!) {
  getProductVariantImages(advertId: $advertId) {
    __typename
    ... on productVariantImageList {
      items {
        url
        sku
        filename
        position
      }
    }
  }
}
    `;
export const GetProducts = gql`
    query GetProducts($random: String, $sortOrder: sortOrder, $limit: Int, $from: Int, $sortBy: String, $searchTerm: String, $productFilters: inputProductFilters, $trendingNow: Boolean) {
  getProducts(
    random: $random
    sortOrder: $sortOrder
    limit: $limit
    from: $from
    sortBy: $sortBy
    searchTerm: $searchTerm
    productFilters: $productFilters
    trendingNow: $trendingNow
  ) {
    __typename
    ... on productList {
      total
      items {
        ...ProductParts
        ...ProductECommerceParts
      }
      brands {
        ...BrandParts
      }
    }
  }
}
    ${ProductParts}
${ProductECommerceParts}
${BrandParts}`;
export const GetProductsBrandsFromCatalogue = gql`
    query getProductsBrandsFromCatalogue($random: String, $sortOrder: sortOrder, $limit: Int, $from: Int, $sortBy: String, $searchTerm: String, $productFilters: inputProductFilters) {
  getProducts(
    random: $random
    sortOrder: $sortOrder
    limit: $limit
    from: $from
    sortBy: $sortBy
    searchTerm: $searchTerm
    productFilters: $productFilters
  ) {
    __typename
    ... on productList {
      total
      brands {
        ...BrandParts
      }
    }
  }
}
    ${BrandParts}`;
export const GetProductsFromPersonalization = gql`
    query GetProductsFromPersonalization($sortOrder: sortOrder, $limit: Int, $from: Int, $sortBy: String, $searchTerm: String, $productFilters: inputProductFilters) {
  getProductsFromPersonalization(
    sortOrder: $sortOrder
    limit: $limit
    from: $from
    sortBy: $sortBy
    searchTerm: $searchTerm
    productFilters: $productFilters
  ) {
    __typename
    ... on productList {
      total
      items {
        ...ProductParts
        ...ProductECommerceParts
      }
    }
  }
}
    ${ProductParts}
${ProductECommerceParts}`;
export const GetProductsForSearchV2 = gql`
    query GetProductsForSearchV2($limit: Int, $from: Int, $searchTerm: String, $productFilters: inputProductFilters, $sortBy: String, $sortOrder: sortOrder) {
  getProductsForSearchV2(
    limit: $limit
    from: $from
    searchTerm: $searchTerm
    productFilters: $productFilters
    sortOrder: $sortOrder
    sortBy: $sortBy
  ) {
    __typename
    ... on v2SearchProductList {
      total
      autocorrectedSearchTerms
      items {
        ...ProductParts
        ...ProductECommerceParts
      }
    }
  }
}
    ${ProductParts}
${ProductECommerceParts}`;
export const GetProductsMinimalFields = gql`
    query GetProductsMinimalFields($sortOrder: sortOrder, $limit: Int, $sortBy: String) {
  getProducts(
    sortOrder: $sortOrder
    limit: $limit
    from: 0
    sortBy: $sortBy
    searchTerm: ""
    productFilters: {}
  ) {
    __typename
    ... on productList {
      total
      items {
        __typename
        product_id
        product_advertLookUp
        product_name
        product_hideDate
        product_endDate
        product_retailer {
          retailer_displayName
        }
        product_isDuplicate
      }
    }
  }
}
    `;
export const GetProductsForSearch = gql`
    query GetProductsForSearch($limit: Int, $from: Int, $searchTerm: String, $productFilters: inputProductFilters) {
  getProductsForSearch(
    limit: $limit
    from: $from
    searchTerm: $searchTerm
    productFilters: $productFilters
  ) {
    __typename
    ... on productList {
      total
      items {
        ...ProductParts
        ...ProductECommerceParts
      }
    }
  }
}
    ${ProductParts}
${ProductECommerceParts}`;
export const GetRetailers = gql`
    query getRetailers($sortOrder: sortOrder, $limit: Int, $from: Int, $sortBy: String, $searchTerm: String, $productFilters: inputProductFilters, $filterbyRetailerName: String) {
  getRetailers(
    sortOrder: $sortOrder
    limit: $limit
    from: $from
    sortBy: $sortBy
    searchTerm: $searchTerm
    productFilters: $productFilters
    filterbyRetailerName: $filterbyRetailerName
  ) {
    __typename
    ... on error {
      error_code
      error_message
    }
    ... on retailerList {
      total
      items {
        ...RetailerParts
      }
    }
  }
}
    ${RetailerParts}`;
export const GetSimilarProducts = gql`
    query GetSimilarProducts($productId: String!, $exactMatch: Boolean, $limit: Int) {
  getSimilarProducts(
    productId: $productId
    exactMatch: $exactMatch
    limit: $limit
  ) {
    __typename
    ... on productList {
      total
      retailerCount
      items {
        ...ProductParts
        ...ProductECommerceParts
      }
    }
  }
}
    ${ProductParts}
${ProductECommerceParts}`;
export const GetTopTenCatalogues = gql`
    query getTopTenCatalogues {
  getTopTenCatalogues {
    __typename
    ... on productGroupList {
      items {
        __typename
        productGroup_productGroupId
        productGroup_displayName
        productGroup_productGroupImage
        productGroup_thumbnailUrl
        productGroup_retailerId
        productGroup_pageLinks {
          pageNumber
          imagePath
          __typename
        }
        productGroup_type
        productGroup_productsTotal
        productGroup_retailer {
          ...RetailerParts
        }
      }
    }
    ... on error {
      __typename
      error_code
      error_message
    }
  }
}
    ${RetailerParts}`;
export const GetUser = gql`
    query getUser {
  getUserProfile {
    __typename
    ... on error {
      error_message
    }
    ... on user {
      userId
      mobile
      firstName
      lastName
      email
      isOver18
      signupCompleted
      signupDate
      preferences {
        postCodes
        retailers
        categories
        brands
        notifications {
          enableNotifications
          enableAppNotifications
          enableEmailNotifications
          enableSMSNotifications
        }
      }
    }
  }
}
    `;
export const GetVariantsForAdvert = gql`
    query GetVariantsForAdvert($id: String!) {
  getVariantsForAdvert(id: $id) {
    __typename
    ... on advertVariantList {
      editablePrice
      editableSalePrice
      totalDomesticShippingCostCents
      total
      items {
        ...VariantParts
        optionValues
      }
      aoStockCodes {
        key
        value
        __typename
      }
    }
    ... on error {
      error_message
    }
  }
}
    ${VariantParts}`;
export const GetWishLists = gql`
    query getWishLists {
  getWishLists {
    ... on wishLists {
      __typename
      total
      items {
        __typename
        id
        name
        productIds
      }
    }
  }
}
    `;
export const GetWishListsFull = gql`
    query getWishListsFull {
  getWishLists {
    ... on wishLists {
      __typename
      total
      items {
        __typename
        id
        name
        productIds
        products {
          ...ProductParts
          ...ProductECommerceParts
        }
      }
    }
  }
}
    ${ProductParts}
${ProductECommerceParts}`;
export const ValidateCartDelivery = gql`
    query validateCartDelivery($customerPostcode: String!, $productIds: [Int!]!) {
  validateCartDelivery(
    customerPostcode: $customerPostcode
    productIds: $productIds
  ) {
    __typename
    ... on error {
      __typename
      error_code
      error_message
    }
    ... on productDeliveryStatus {
      __typename
      items {
        productId
        deliverable
        __typename
      }
    }
  }
}
    `;
export const SubscribeCart = gql`
    subscription subscribeCart($cartId: ID!) {
  subscribeCart(cartId: $cartId) {
    ... on cart {
      ...CartParts
    }
    ... on error {
      __typename
      error_code
      error_message
    }
  }
}
    ${CartParts}`;